export const DUMMY_DATA = [
  {
    date: "2026-05-11",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-286",
                    title: "Evergreen's yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-287",
                    title: "Oak Crest Apartments",
                    status: "completed",
                    startTime: "7:42 AM",
                    endTime: "8:13 AM",
                    address: "3100 N Haskell Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20568",
                    start: "2025-07-28T07:42:00+05:00",
                    end: "2025-07-28T08:13:00+05:00",
                    origin: {
                      lat: 32.80968717938662,
                      lng: -96.79502553992131,
                    },
                    drive_time: "12",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-288",
                    title: "Maplewood Offices",
                    status: "completed",
                    startTime: "8:24 AM",
                    endTime: "8:49 AM",
                    address: "3936 Travis St, Dallas, TX",
                    contract: "Maintenance Agreement 20569",
                    start: "2025-07-28T08:24:00+05:00",
                    end: "2025-07-28T08:49:00+05:00",
                    origin: {
                      lat: 32.812420318228995,
                      lng: -96.79604852067472,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-289",
                    title: "Lakeside Retail Center",
                    status: "completed",
                    startTime: "8:59 AM",
                    endTime: "9:31 AM",
                    address: "4034a Buena Vista St, Dallas, TX",
                    contract: "Maintenance Agreement 20570",
                    start: "2025-07-28T08:59:00+05:00",
                    end: "2025-07-28T09:31:00+05:00",
                    origin: {
                      lat: 32.81436324549151,
                      lng: -96.79627887076978,
                    },
                    drive_time: "10",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-290",
                    title: "Pine Valley Townhomes",
                    status: "completed",
                    startTime: "9:39 AM",
                    endTime: "10:04 AM",
                    address: "4007 Stonebridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20571",
                    start: "2025-07-28T09:39:00+05:00",
                    end: "2025-07-28T10:04:00+05:00",
                    origin: {
                      lat: 32.81636202011015,
                      lng: -96.79676832281925,
                    },
                    drive_time: "8",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-291",
                    title: "Willowbrook Condo",
                    status: "completed",
                    startTime: "10:17 AM",
                    endTime: "10:42 AM",
                    address: "4136 Cole Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20572",
                    start: "2025-07-28T10:17:00+05:00",
                    end: "2025-07-28T10:42:00+05:00",
                    origin: {
                      lat: 32.81564916786807,
                      lng: -96.79247714923689,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-292",
                    title: "Elm Park Plaza",
                    status: "completed",
                    startTime: "10:51 AM",
                    endTime: "11:31 AM",
                    address: "4061 N Central Expy, Dallas, TX",
                    contract: "Maintenance Agreement 20573",
                    start: "2025-07-28T10:51:00+05:00",
                    end: "2025-07-28T11:31:00+05:00",
                    origin: {
                      lat: 32.81354908694805,
                      lng: -96.7912577014335,
                    },
                    drive_time: "9",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-293",
                    title: "Cedar Ridge Village",
                    status: "completed",
                    startTime: "11:41 AM",
                    endTime: "12:14 PM",
                    address: "4114 N Central Expy, Dallas, TX",
                    contract: "Maintenance Agreement 20574",
                    start: "2025-07-28T11:41:00+05:00",
                    end: "2025-07-28T12:14:00+05:00",
                    origin: {
                      lat: 32.81313047201152,
                      lng: -96.7890222835907,
                    },
                    drive_time: "10",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-294",
                    title: "Birchwood Medical",
                    status: "completed",
                    startTime: "12:28 PM",
                    endTime: "12:53 PM",
                    address: "2802 N Carroll Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20575",
                    start: "2025-07-28T12:28:00+05:00",
                    end: "2025-07-28T12:53:00+05:00",
                    origin: {
                      lat: 32.811918200755336,
                      lng: -96.78875237948533,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-295",
                    title: "Dogwood Business Park",
                    status: "completed",
                    startTime: "1:05 PM",
                    endTime: "1:30 PM",
                    address:
                      "Birchwood Apartment Homes, 4829 Coles Manor Pl, Dallas, TX",
                    contract: "Maintenance Agreement 20576",
                    start: "2025-07-28T13:05:00+05:00",
                    end: "2025-07-28T13:30:00+05:00",
                    origin: {
                      lat: 32.812917201451604,
                      lng: -96.78566615676915,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-296",
                    title: "Magnolia Senior Living",
                    status: "completed",
                    startTime: "1:37 PM",
                    endTime: "2:09 PM",
                    address: "4319 Belmont Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20577",
                    start: "2025-07-28T13:37:00+05:00",
                    end: "2025-07-28T14:09:00+05:00",
                    origin: {
                      lat: 32.808547324041506,
                      lng: -96.78931852971077,
                    },
                    drive_time: "7",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-297",
                    title: "Aspen Heights School",
                    status: "completed",
                    startTime: "2:19 PM",
                    endTime: "2:44 PM",
                    address: "2409 N Henderson Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20578",
                    start: "2025-07-28T14:19:00+05:00",
                    end: "2025-07-28T14:44:00+05:00",
                    origin: {
                      lat: 32.815060654789114,
                      lng: -96.77892301199331,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-298",
                    title: "Sycamore Fitness Center",
                    status: "completed",
                    startTime: "2:57 PM",
                    endTime: "3:23 PM",
                    address: "7 McKinney Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20579",
                    start: "2025-07-28T14:57:00+05:00",
                    end: "2025-07-28T15:23:00+05:00",
                    origin: {
                      lat: 32.82044107805568,
                      lng: -96.78900343145571,
                    },
                    drive_time: "13",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-299",
                    title: "Juniper Villas",
                    status: "completed",
                    startTime: "3:34 PM",
                    endTime: "3:59 PM",
                    address: "3504 Overbrook Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20580",
                    start: "2025-07-28T15:34:00+05:00",
                    end: "2025-07-28T15:59:00+05:00",
                    origin: {
                      lat: 32.82045391775728,
                      lng: -96.79438485741689,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-300",
                    title: "Evergreen's yard",
                    status: "completed",
                    startTime: "3:59 PM",
                    endTime: "4:29 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T15:59:00+05:00",
                    end: "2025-07-28T16:29:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-413",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-414",
                    title: "Casa View Plaza",
                    status: "completed",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "15771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-07-28T07:45:00+05:00",
                    end: "2025-07-28T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-415",
                    title: "Kessler Plaza",
                    status: "completed",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "155010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-07-28T08:45:00+05:00",
                    end: "2025-07-28T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-416",
                    title: "Dallas Garden Center",
                    status: "completed",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "553 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-07-28T09:15:00+05:00",
                    end: "2025-07-28T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-417",
                    title: "Bishop Arts Retail",
                    status: "completed",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "205909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-07-28T10:00:00+05:00",
                    end: "2025-07-28T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-418",
                    title: "Elmwood Bungalows",
                    status: "completed",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-07-28T11:03:00+05:00",
                    end: "2025-07-28T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "34",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-419",
                    title: "Rosemont HOA",
                    status: "completed",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-07-28T11:57:00+05:00",
                    end: "2025-07-28T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-420",
                    title: "Lakeside Apartments",
                    status: "completed",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "20518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-07-28T12:42:00+05:00",
                    end: "2025-07-28T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "36",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-421",
                    title: "Eastwood HOA",
                    status: "completed",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-07-28T13:23:00+05:00",
                    end: "2025-07-28T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-422",
                    title: "Mockingbird Medical Plaza",
                    status: "completed",
                    startTime: "2:03 PM",
                    endTime: "3:45 PM",
                    address: "15701 Royal Birkdale Dr, Dallas, TX",
                    contract: "Irrigation Service 9893",
                    start: "2025-07-28T14:03:00+05:00",
                    end: "2025-07-28T15:45:00+05:00",
                    origin: {
                      lat: 32.9735088764031,
                      lng: -96.63629889037135,
                    },
                    drive_time: "102",
                    durationMinutes: 102,
                  },
                  {
                    id: "landscape_maintenance-visit-423",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T15:45:00+05:00",
                    end: "2025-07-28T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-520",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-521",
                    title: "Preston Hollow Estates",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-28T07:40:00+05:00",
                    end: "2025-07-28T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-522",
                    title: "Park Lane Terraces",
                    status: "completed",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-28T09:08:00+05:00",
                    end: "2025-07-28T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-523",
                    title: "Maple District Commons",
                    status: "completed",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-28T10:08:00+05:00",
                    end: "2025-07-28T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-524",
                    title: "Highland Greens",
                    status: "completed",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-28T11:01:00+05:00",
                    end: "2025-07-28T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-525",
                    title: "Casa Linda Enclave",
                    status: "completed",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-28T12:30:00+05:00",
                    end: "2025-07-28T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-526",
                    title: "Lakewood Gardens",
                    status: "completed",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-28T13:58:00+05:00",
                    end: "2025-07-28T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-527",
                    title: "Briarwood Villas",
                    status: "completed",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-28T14:46:00+05:00",
                    end: "2025-07-28T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-528",
                    title: "Oak Cliff Residences",
                    status: "completed",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-28T15:35:00+05:00",
                    end: "2025-07-28T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-529",
                    title: "Northwood Hills",
                    status: "completed",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-28T16:23:00+05:00",
                    end: "2025-07-28T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-530",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T17:58:00+05:00",
                    end: "2025-07-28T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-620",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "348636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-621",
                    title: "Mockingbird Plaza",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "3:21 PM",
                    address: "46119610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-28T07:40:00+05:00",
                    end: "2025-07-28T15:21:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-622",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T15:40:00+05:00",
                    end: "2025-07-28T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-12",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-301",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "8",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-302",
                    title: "Oakdale Senior Center",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "8:15 AM",
                    address: "5637 Hunters Bend Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20584",
                    start: "2025-07-29T07:40:00+05:00",
                    end: "2025-07-29T08:15:00+05:00",
                    origin: {
                      lat: 32.65537421687229,
                      lng: -96.97332544996381,
                    },
                    drive_time: "10",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-303",
                    title: "Brookstone Plaza",
                    status: "completed",
                    startTime: "8:26 AM",
                    endTime: "8:51 AM",
                    address: "5621 Bandit Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20585",
                    start: "2025-07-29T08:26:00+05:00",
                    end: "2025-07-29T08:51:00+05:00",
                    origin: {
                      lat: 32.65793132845956,
                      lng: -96.96997676403906,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-304",
                    title: "Elm Creek HOA",
                    status: "completed",
                    startTime: "8:57 AM",
                    endTime: "9:30 AM",
                    address: "5666 Mountain Hollow Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20586",
                    start: "2025-07-29T08:57:00+05:00",
                    end: "2025-07-29T09:30:00+05:00",
                    origin: {
                      lat: 32.65727746412962,
                      lng: -96.96548980363775,
                    },
                    drive_time: "6",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-305",
                    title: "Highland Commons",
                    status: "completed",
                    startTime: "9:37 AM",
                    endTime: "10:05 AM",
                    address: "5680 Centeridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20587",
                    start: "2025-07-29T09:37:00+05:00",
                    end: "2025-07-29T10:05:00+05:00",
                    origin: {
                      lat: 32.65848800584531,
                      lng: -96.96247565034557,
                    },
                    drive_time: "7",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-306",
                    title: "Briarwood Medical",
                    status: "completed",
                    startTime: "10:18 AM",
                    endTime: "10:43 AM",
                    address: "7917 Vista Hill Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20588",
                    start: "2025-07-29T10:18:00+05:00",
                    end: "2025-07-29T10:43:00+05:00",
                    origin: {
                      lat: 32.65588730116591,
                      lng: -96.96155785883717,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-307",
                    title: "Lakeview Apartments",
                    status: "completed",
                    startTime: "10:52 AM",
                    endTime: "11:23 AM",
                    address: "8635-8799 Granville Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20589",
                    start: "2025-07-29T10:52:00+05:00",
                    end: "2025-07-29T11:23:00+05:00",
                    origin: {
                      lat: 32.657329702530106,
                      lng: -96.95182588465576,
                    },
                    drive_time: "9",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-308",
                    title: "Whispering Pines Park",
                    status: "completed",
                    startTime: "11:33 AM",
                    endTime: "11:58 AM",
                    address: "8441 Clark Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20590",
                    start: "2025-07-29T11:33:00+05:00",
                    end: "2025-07-29T11:58:00+05:00",
                    origin: {
                      lat: 32.66098299324898,
                      lng: -96.94440557908295,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-309",
                    title: "Sunset Commercial Lot",
                    status: "completed",
                    startTime: "12:04 PM",
                    endTime: "12:29 PM",
                    address: "61407 W Ridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20591",
                    start: "2025-07-29T12:04:00+05:00",
                    end: "2025-07-29T12:29:00+05:00",
                    origin: {
                      lat: 32.656571503312556,
                      lng: -96.94134323823776,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-310",
                    title: "Orchard Villas",
                    status: "completed",
                    startTime: "12:41 PM",
                    endTime: "1:06 PM",
                    address: "6823 Cedar Forest Trail, Dallas, TX",
                    contract: "Maintenance Agreement 20592",
                    start: "2025-07-29T12:41:00+05:00",
                    end: "2025-07-29T13:06:00+05:00",
                    origin: {
                      lat: 32.664738578647075,
                      lng: -96.93503995031634,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-311",
                    title: "Linden Estates",
                    status: "completed",
                    startTime: "1:19 PM",
                    endTime: "1:49 PM",
                    address: "6927 Clarkridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20593",
                    start: "2025-07-29T13:19:00+05:00",
                    end: "2025-07-29T13:49:00+05:00",
                    origin: {
                      lat: 32.66781678212907,
                      lng: -96.9434105721135,
                    },
                    drive_time: "13",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-312",
                    title: "Redbud Office Center",
                    status: "completed",
                    startTime: "2:03 PM",
                    endTime: "2:35 PM",
                    address: "8303 Timberbrook Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20594",
                    start: "2025-07-29T14:03:00+05:00",
                    end: "2025-07-29T14:35:00+05:00",
                    origin: {
                      lat: 32.66542401234956,
                      lng: -96.95120340724914,
                    },
                    drive_time: "14",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-313",
                    title: "Windsor Hill Retail",
                    status: "completed",
                    startTime: "2:48 PM",
                    endTime: "3:13 PM",
                    address: "6640 Legters Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20595",
                    start: "2025-07-29T14:48:00+05:00",
                    end: "2025-07-29T15:13:00+05:00",
                    origin: {
                      lat: 32.667104262352105,
                      lng: -96.95313191395635,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-314",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "3:13 PM",
                    endTime: "3:43 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T15:13:00+05:00",
                    end: "2025-07-29T15:43:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-424",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-425",
                    title: "Preston Hollow Estates",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-29T07:40:00+05:00",
                    end: "2025-07-29T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-426",
                    title: "Park Lane Terraces",
                    status: "completed",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-29T09:08:00+05:00",
                    end: "2025-07-29T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-427",
                    title: "Maple District Commons",
                    status: "completed",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-29T10:08:00+05:00",
                    end: "2025-07-29T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-428",
                    title: "Highland Greens",
                    status: "completed",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-29T11:01:00+05:00",
                    end: "2025-07-29T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-429",
                    title: "Casa Linda Enclave",
                    status: "completed",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-29T12:30:00+05:00",
                    end: "2025-07-29T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-430",
                    title: "Lakewood Gardens",
                    status: "completed",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-29T13:58:00+05:00",
                    end: "2025-07-29T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-431",
                    title: "Briarwood Villas",
                    status: "completed",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-29T14:46:00+05:00",
                    end: "2025-07-29T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-432",
                    title: "Oak Cliff Residences",
                    status: "completed",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-29T15:35:00+05:00",
                    end: "2025-07-29T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-433",
                    title: "Northwood Hills",
                    status: "completed",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-29T16:23:00+05:00",
                    end: "2025-07-29T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-434",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T17:58:00+05:00",
                    end: "2025-07-29T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-531",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-532",
                    title: "Casa View Plaza",
                    status: "completed",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "15771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-07-29T07:45:00+05:00",
                    end: "2025-07-29T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-533",
                    title: "Kessler Plaza",
                    status: "completed",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "155010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-07-29T08:45:00+05:00",
                    end: "2025-07-29T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-534",
                    title: "Dallas Garden Center",
                    status: "completed",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "553 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-07-29T09:15:00+05:00",
                    end: "2025-07-29T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-535",
                    title: "Bishop Arts Retail",
                    status: "completed",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "205909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-07-29T10:00:00+05:00",
                    end: "2025-07-29T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-536",
                    title: "Elmwood Bungalows",
                    status: "completed",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-07-29T11:03:00+05:00",
                    end: "2025-07-29T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "34",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-537",
                    title: "Rosemont HOA",
                    status: "completed",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-07-29T11:57:00+05:00",
                    end: "2025-07-29T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-538",
                    title: "Lakeside Apartments",
                    status: "completed",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "20518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-07-29T12:42:00+05:00",
                    end: "2025-07-29T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "36",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-539",
                    title: "Eastwood HOA",
                    status: "completed",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-07-29T13:23:00+05:00",
                    end: "2025-07-29T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-540",
                    title: "Mockingbird Medical Plaza",
                    status: "completed",
                    startTime: "2:03 PM",
                    endTime: "3:45 PM",
                    address: "15701 Royal Birkdale Dr, Dallas, TX",
                    contract: "Irrigation Service 9893",
                    start: "2025-07-29T14:03:00+05:00",
                    end: "2025-07-29T15:45:00+05:00",
                    origin: {
                      lat: 32.9735088764031,
                      lng: -96.63629889037135,
                    },
                    drive_time: "102",
                    durationMinutes: 102,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-541",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T15:45:00+05:00",
                    end: "2025-07-29T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-623",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "348636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-624",
                    title: "Mockingbird Plaza",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "3:21 PM",
                    address: "46139610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-29T07:40:00+05:00",
                    end: "2025-07-29T15:21:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-625",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "4:00 PM",
                    endTime: "4:30 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T16:00:00+05:00",
                    end: "2025-07-29T16:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-13",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-315",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-316",
                    title: "Laurel Park Commons",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:06 AM",
                    address: "72200 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20628",
                    start: "2025-07-30T07:37:00+05:00",
                    end: "2025-07-30T08:06:00+05:00",
                    origin: {
                      lat: 32.82700062143119,
                      lng: -96.97545355404942,
                    },
                    drive_time: "29",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-317",
                    title: "Willowview HOA",
                    status: "completed",
                    startTime: "8:18 AM",
                    endTime: "8:44 AM",
                    address: "121603 Priscilla Ln, Irving, TX",
                    contract: "Maintenance Agreement 20629",
                    start: "2025-07-30T08:18:00+05:00",
                    end: "2025-07-30T08:44:00+05:00",
                    origin: {
                      lat: 32.83158778723434,
                      lng: -96.97103910479787,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-318",
                    title: "Fox Hill Plaza",
                    status: "completed",
                    startTime: "9:33 AM",
                    endTime: "10:06 AM",
                    address: "13267 W St Clair Dr, Irving, TX",
                    contract: "Maintenance Agreement 20631",
                    start: "2025-07-30T09:33:00+05:00",
                    end: "2025-07-30T10:06:00+05:00",
                    origin: {
                      lat: 32.82459779966745,
                      lng: -96.96212813072863,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-319",
                    title: "Northaven Suites",
                    status: "completed",
                    startTime: "10:13 AM",
                    endTime: "10:38 AM",
                    address: "71311 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20632",
                    start: "2025-07-30T10:13:00+05:00",
                    end: "2025-07-30T10:38:00+05:00",
                    origin: {
                      lat: 32.81738323907385,
                      lng: -96.96163571966576,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-320",
                    title: "Springridge Center",
                    status: "completed",
                    startTime: "10:48 AM",
                    endTime: "11:15 AM",
                    address: "101309 Limetree Ln, Irving, TX",
                    contract: "Maintenance Agreement 20633",
                    start: "2025-07-30T10:48:00+05:00",
                    end: "2025-07-30T11:15:00+05:00",
                    origin: {
                      lat: 32.82658243688681,
                      lng: -96.95362221982374,
                    },
                    drive_time: "10",
                    durationMinutes: 27,
                  },
                  {
                    id: "landscape_maintenance-visit-321",
                    title: "Midpark Towers",
                    status: "completed",
                    startTime: "11:20 AM",
                    endTime: "12:05 PM",
                    address: "51118 Brady Dr, Irving, TX",
                    contract: "Maintenance Agreement 20634",
                    start: "2025-07-30T11:20:00+05:00",
                    end: "2025-07-30T12:05:00+05:00",
                    origin: {
                      lat: 32.82671809190914,
                      lng: -96.94998831806257,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-322",
                    title: "Cottonwood Villas",
                    status: "completed",
                    startTime: "12:13 PM",
                    endTime: "12:39 PM",
                    address: "81946 Shoaf Dr, Irving, TX",
                    contract: "Maintenance Agreement 20635",
                    start: "2025-07-30T12:13:00+05:00",
                    end: "2025-07-30T12:39:00+05:00",
                    origin: {
                      lat: 32.83422926324008,
                      lng: -96.94588238382623,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-323",
                    title: "Valley Glen Retail",
                    status: "completed",
                    startTime: "12:45 PM",
                    endTime: "1:10 PM",
                    address: "62021 Shoaf Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20636",
                    start: "2025-07-30T12:45:00+05:00",
                    end: "2025-07-30T13:10:00+05:00",
                    origin: {
                      lat: 32.83518441521939,
                      lng: -96.94790165829477,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-324",
                    title: "Hidden Creek Plaza",
                    status: "completed",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "13122 W Holland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20637",
                    start: "2025-07-30T13:23:00+05:00",
                    end: "2025-07-30T13:48:00+05:00",
                    origin: {
                      lat: 32.83841754739589,
                      lng: -96.94561778664372,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-325",
                    title: "Ridgewood Shops",
                    status: "completed",
                    startTime: "1:55 PM",
                    endTime: "2:26 PM",
                    address: "72326 W Newton Cir, Dallas, TX",
                    contract: "Maintenance Agreement 20638",
                    start: "2025-07-30T13:55:00+05:00",
                    end: "2025-07-30T14:26:00+05:00",
                    origin: {
                      lat: 32.83931617496474,
                      lng: -96.94817451366447,
                    },
                    drive_time: "7",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-326",
                    title: "Southside Gardens",
                    status: "completed",
                    startTime: "2:37 PM",
                    endTime: "3:02 PM",
                    address: "112328 Brockbank Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20639",
                    start: "2025-07-30T14:37:00+05:00",
                    end: "2025-07-30T15:02:00+05:00",
                    origin: {
                      lat: 32.83917228935476,
                      lng: -96.94994426998946,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-327",
                    title: "The Gables at Oak",
                    status: "completed",
                    startTime: "3:16 PM",
                    endTime: "3:41 PM",
                    address: "14120 E Scotland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20640",
                    start: "2025-07-30T15:16:00+05:00",
                    end: "2025-07-30T15:41:00+05:00",
                    origin: {
                      lat: 32.840372057900865,
                      lng: -96.94357860432224,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-328",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "4:36 PM",
                    endTime: "5:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T16:36:00+05:00",
                    end: "2025-07-30T17:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-435",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "8",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-436",
                    title: "Oakdale Senior Center",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "8:15 AM",
                    address: "5637 Hunters Bend Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20584",
                    start: "2025-07-30T07:40:00+05:00",
                    end: "2025-07-30T08:15:00+05:00",
                    origin: {
                      lat: 32.65537421687229,
                      lng: -96.97332544996381,
                    },
                    drive_time: "10",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-437",
                    title: "Brookstone Plaza",
                    status: "completed",
                    startTime: "8:26 AM",
                    endTime: "8:51 AM",
                    address: "5621 Bandit Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20585",
                    start: "2025-07-30T08:26:00+05:00",
                    end: "2025-07-30T08:51:00+05:00",
                    origin: {
                      lat: 32.65793132845956,
                      lng: -96.96997676403906,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-438",
                    title: "Elm Creek HOA",
                    status: "completed",
                    startTime: "8:57 AM",
                    endTime: "9:30 AM",
                    address: "5666 Mountain Hollow Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20586",
                    start: "2025-07-30T08:57:00+05:00",
                    end: "2025-07-30T09:30:00+05:00",
                    origin: {
                      lat: 32.65727746412962,
                      lng: -96.96548980363775,
                    },
                    drive_time: "6",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-439",
                    title: "Highland Commons",
                    status: "completed",
                    startTime: "9:37 AM",
                    endTime: "10:05 AM",
                    address: "5680 Centeridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20587",
                    start: "2025-07-30T09:37:00+05:00",
                    end: "2025-07-30T10:05:00+05:00",
                    origin: {
                      lat: 32.65848800584531,
                      lng: -96.96247565034557,
                    },
                    drive_time: "7",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-440",
                    title: "Lakeview Apartments",
                    status: "completed",
                    startTime: "10:52 AM",
                    endTime: "11:23 AM",
                    address: "8635-8799 Granville Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20589",
                    start: "2025-07-30T10:52:00+05:00",
                    end: "2025-07-30T11:23:00+05:00",
                    origin: {
                      lat: 32.657329702530106,
                      lng: -96.95182588465576,
                    },
                    drive_time: "31",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-441",
                    title: "Whispering Pines Park",
                    status: "completed",
                    startTime: "11:33 AM",
                    endTime: "11:58 AM",
                    address: "8441 Clark Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20590",
                    start: "2025-07-30T11:33:00+05:00",
                    end: "2025-07-30T11:58:00+05:00",
                    origin: {
                      lat: 32.66098299324898,
                      lng: -96.94440557908295,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-442",
                    title: "Sunset Commercial Lot",
                    status: "completed",
                    startTime: "12:04 PM",
                    endTime: "12:29 PM",
                    address: "61407 W Ridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20591",
                    start: "2025-07-30T12:04:00+05:00",
                    end: "2025-07-30T12:29:00+05:00",
                    origin: {
                      lat: 32.656571503312556,
                      lng: -96.94134323823776,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-443",
                    title: "Orchard Villas",
                    status: "completed",
                    startTime: "12:41 PM",
                    endTime: "1:06 PM",
                    address: "6823 Cedar Forest Trail, Dallas, TX",
                    contract: "Maintenance Agreement 20592",
                    start: "2025-07-30T12:41:00+05:00",
                    end: "2025-07-30T13:06:00+05:00",
                    origin: {
                      lat: 32.664738578647075,
                      lng: -96.93503995031634,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-444",
                    title: "Linden Estates",
                    status: "completed",
                    startTime: "1:19 PM",
                    endTime: "1:49 PM",
                    address: "6927 Clarkridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20593",
                    start: "2025-07-30T13:19:00+05:00",
                    end: "2025-07-30T13:49:00+05:00",
                    origin: {
                      lat: 32.66781678212907,
                      lng: -96.9434105721135,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-445",
                    title: "Redbud Office Center",
                    status: "completed",
                    startTime: "2:03 PM",
                    endTime: "2:35 PM",
                    address: "8303 Timberbrook Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20594",
                    start: "2025-07-30T14:03:00+05:00",
                    end: "2025-07-30T14:35:00+05:00",
                    origin: {
                      lat: 32.66542401234956,
                      lng: -96.95120340724914,
                    },
                    drive_time: "32",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-446",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "3:13 PM",
                    endTime: "3:43 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T15:13:00+05:00",
                    end: "2025-07-30T15:43:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-542",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "78636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-543",
                    title: "Eastwood HOA",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-07-30T07:37:00+05:00",
                    end: "2025-07-30T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-544",
                    title: "Bishop Arts Retail",
                    status: "completed",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-07-30T08:40:00+05:00",
                    end: "2025-07-30T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-545",
                    title: "Elmwood Bungalows",
                    status: "completed",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-07-30T09:17:00+05:00",
                    end: "2025-07-30T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-546",
                    title: "Kessler Plaza",
                    status: "completed",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-07-30T09:54:00+05:00",
                    end: "2025-07-30T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-547",
                    title: "Lakeside Apartments",
                    status: "completed",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-07-30T11:02:00+05:00",
                    end: "2025-07-30T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "49",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-548",
                    title: "Dallas Garden Center",
                    status: "completed",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-07-30T11:56:00+05:00",
                    end: "2025-07-30T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-549",
                    title: "Rosemont HOA",
                    status: "completed",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-07-30T13:40:00+05:00",
                    end: "2025-07-30T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-550",
                    title: "Casa View Plaza",
                    status: "completed",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-07-30T14:23:00+05:00",
                    end: "2025-07-30T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-551",
                    title: "Mockingbird Medical Plaza",
                    status: "completed",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-07-30T14:55:00+05:00",
                    end: "2025-07-30T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-552",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T15:20:00+05:00",
                    end: "2025-07-30T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-626",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "248636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-627",
                    title: "Mockingbird Plaza",
                    status: "completed",
                    startTime: "7:30 AM",
                    endTime: "3:11 PM",
                    address: "46119610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-30T07:30:00+05:00",
                    end: "2025-07-30T15:11:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-628",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:30 PM",
                    endTime: "4:00 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T15:30:00+05:00",
                    end: "2025-07-30T16:00:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-14",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-329",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "7",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-330",
                    title: "Eastwood HOA",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "6900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-07-31T07:37:00+05:00",
                    end: "2025-07-31T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "7",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-331",
                    title: "Bishop Arts Retail",
                    status: "completed",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "3333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-07-31T08:40:00+05:00",
                    end: "2025-07-31T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-332",
                    title: "Elmwood Bungalows",
                    status: "completed",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "6550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-07-31T09:17:00+05:00",
                    end: "2025-07-31T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-333",
                    title: "Kessler Plaza",
                    status: "completed",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "6706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-07-31T09:54:00+05:00",
                    end: "2025-07-31T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "12",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-334",
                    title: "Lakeside Apartments",
                    status: "completed",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "6723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-07-31T11:02:00+05:00",
                    end: "2025-07-31T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "20",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-335",
                    title: "Dallas Garden Center",
                    status: "completed",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "6724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-07-31T11:56:00+05:00",
                    end: "2025-07-31T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "5",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-336",
                    title: "Rosemont HOA",
                    status: "completed",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "7015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-07-31T13:40:00+05:00",
                    end: "2025-07-31T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-337",
                    title: "Casa View Plaza",
                    status: "completed",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "5530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-07-31T14:23:00+05:00",
                    end: "2025-07-31T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "18",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-338",
                    title: "Mockingbird Medical Plaza",
                    status: "completed",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-07-31T14:55:00+05:00",
                    end: "2025-07-31T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-339",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:20:00+05:00",
                    end: "2025-07-31T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-447",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-448",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-31T07:40:00+05:00",
                    end: "2025-07-31T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-449",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-31T09:08:00+05:00",
                    end: "2025-07-31T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-450",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-31T10:08:00+05:00",
                    end: "2025-07-31T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-451",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-31T11:01:00+05:00",
                    end: "2025-07-31T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-452",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-31T12:30:00+05:00",
                    end: "2025-07-31T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-453",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-31T13:58:00+05:00",
                    end: "2025-07-31T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-454",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-31T15:35:00+05:00",
                    end: "2025-07-31T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-455",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-31T16:23:00+05:00",
                    end: "2025-07-31T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-456",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-31T17:15:00+05:00",
                    end: "2025-07-31T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-457",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T17:58:00+05:00",
                    end: "2025-07-31T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-553",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "13",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-554",
                    title: "Highland Greens",
                    status: "completed",
                    startTime: "7:30 AM",
                    endTime: "8:24 AM",
                    address: "133500 McDermott Rd, Plano, TX",
                    contract: "Enhancement Agreement 7535",
                    start: "2025-07-31T07:30:00+05:00",
                    end: "2025-07-31T08:24:00+05:00",
                    origin: {
                      lat: 33.09731135791416,
                      lng: -96.7561612900574,
                    },
                    drive_time: "54",
                    durationMinutes: 54,
                  },
                  {
                    id: "landscape_maintenance-visit-555",
                    title: "Lakewood Gardens",
                    status: "completed",
                    startTime: "8:37 AM",
                    endTime: "10:15 AM",
                    address:
                      "15 Hendrick Football Fields, 7500 Red River Dr, Plano, TX",
                    contract: "Enhancement Agreement 1845",
                    start: "2025-07-31T08:37:00+05:00",
                    end: "2025-07-31T10:15:00+05:00",
                    origin: {
                      lat: 33.078958875996925,
                      lng: -96.72165675801857,
                    },
                    drive_time: "98",
                    durationMinutes: 98,
                  },
                  {
                    id: "landscape_maintenance-visit-556",
                    title: "Casa Linda Enclave",
                    status: "completed",
                    startTime: "10:30 AM",
                    endTime: "11:29 AM",
                    address:
                      "7 Park Forest North, 33.06143375474646, -96.71594615605248 Plano, TX",
                    contract: "Enhancement Agreement 9636",
                    start: "2025-07-31T10:30:00+05:00",
                    end: "2025-07-31T11:29:00+05:00",
                    origin: {
                      lat: 33.06143375474646,
                      lng: -96.71594615605248,
                    },
                    drive_time: "59",
                    durationMinutes: 59,
                  },
                  {
                    id: "landscape_maintenance-visit-557",
                    title: "Park Lane Terraces",
                    status: "completed",
                    startTime: "11:36 AM",
                    endTime: "12:26 PM",
                    address:
                      "20 Horseshoe Park, 4012 Roundrock Trail, Plano, TX",
                    contract: "Enhancement Agreement 7326",
                    start: "2025-07-31T11:36:00+05:00",
                    end: "2025-07-31T12:26:00+05:00",
                    origin: {
                      lat: 33.05116383745358,
                      lng: -96.74307677041843,
                    },
                    drive_time: "50",
                    durationMinutes: 50,
                  },
                  {
                    id: "landscape_maintenance-visit-558",
                    title: "Northwood Hills",
                    status: "completed",
                    startTime: "12:46 PM",
                    endTime: "1:58 PM",
                    address: "16 Preston Meadow Trail, Plano, TX",
                    contract: "Enhancement Agreement 7787",
                    start: "2025-07-31T12:46:00+05:00",
                    end: "2025-07-31T13:58:00+05:00",
                    origin: {
                      lat: 33.04736843936786,
                      lng: -96.77789681362674,
                    },
                    drive_time: "72",
                    durationMinutes: 72,
                  },
                  {
                    id: "landscape_maintenance-visit-559",
                    title: "Oak Cliff Residences",
                    status: "completed",
                    startTime: "2:14 PM",
                    endTime: "3:20 PM",
                    address: "156700 Archgate Dr, Plano, TX",
                    contract: "Enhancement Agreement 8492",
                    start: "2025-07-31T14:14:00+05:00",
                    end: "2025-07-31T15:20:00+05:00",
                    origin: {
                      lat: 33.061422515300954,
                      lng: -96.78223928424197,
                    },
                    drive_time: "66",
                    durationMinutes: 66,
                  },
                  {
                    id: "landscape_maintenance-visit-560",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:35 PM",
                    endTime: "4:05 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:35:00+05:00",
                    end: "2025-07-31T16:05:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-629",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "248636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-630",
                    title: "Mockingbird Plaza",
                    status: "completed",
                    startTime: "7:30 AM",
                    endTime: "3:11 PM",
                    address: "46129610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-31T07:30:00+05:00",
                    end: "2025-07-31T15:11:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-631",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:40:00+05:00",
                    end: "2025-07-31T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-15",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-340",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-341",
                    title: "Casa View Plaza",
                    status: "completed",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-08-01T07:45:00+05:00",
                    end: "2025-08-01T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "15",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-342",
                    title: "Kessler Plaza",
                    status: "completed",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "5010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-08-01T08:45:00+05:00",
                    end: "2025-08-01T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "15",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-343",
                    title: "Dallas Garden Center",
                    status: "completed",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "533 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-08-01T09:15:00+05:00",
                    end: "2025-08-01T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "5",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-344",
                    title: "Bishop Arts Retail",
                    status: "completed",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "5909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-08-01T10:00:00+05:00",
                    end: "2025-08-01T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "20",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-345",
                    title: "Elmwood Bungalows",
                    status: "completed",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-08-01T11:03:00+05:00",
                    end: "2025-08-01T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "15",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-346",
                    title: "Rosemont HOA",
                    status: "completed",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-08-01T11:57:00+05:00",
                    end: "2025-08-01T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "20",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-347",
                    title: "Lakeside Apartments",
                    status: "completed",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-08-01T12:42:00+05:00",
                    end: "2025-08-01T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "20",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-348",
                    title: "Eastwood HOA",
                    status: "completed",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-08-01T13:23:00+05:00",
                    end: "2025-08-01T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "5",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-349",
                    title: "Mockingbird Medical Plaza",
                    status: "completed",
                    startTime: "2:03 PM",
                    endTime: "3:45 PM",
                    address: "15701 Royal Birkdale Dr, Dallas, TX",
                    contract: "Irrigation Service 9893",
                    start: "2025-08-01T14:03:00+05:00",
                    end: "2025-08-01T15:45:00+05:00",
                    origin: {
                      lat: 32.9735088764031,
                      lng: -96.63629889037135,
                    },
                    drive_time: "102",
                    durationMinutes: 102,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-350",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T15:45:00+05:00",
                    end: "2025-08-01T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-458",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "7",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-459",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-08-01T07:37:00+05:00",
                    end: "2025-08-01T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "7",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-460",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-08-01T08:40:00+05:00",
                    end: "2025-08-01T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-461",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-08-01T09:17:00+05:00",
                    end: "2025-08-01T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-462",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-08-01T09:54:00+05:00",
                    end: "2025-08-01T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "12",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-463",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-08-01T11:02:00+05:00",
                    end: "2025-08-01T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "20",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-464",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-08-01T11:56:00+05:00",
                    end: "2025-08-01T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-465",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-08-01T13:40:00+05:00",
                    end: "2025-08-01T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-466",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-08-01T14:23:00+05:00",
                    end: "2025-08-01T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "18",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-467",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-08-01T14:55:00+05:00",
                    end: "2025-08-01T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-468",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T15:20:00+05:00",
                    end: "2025-08-01T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-561",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-562",
                    title: "Preston Hollow Estates",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-08-01T07:40:00+05:00",
                    end: "2025-08-01T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-563",
                    title: "Park Lane Terraces",
                    status: "completed",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-08-01T09:08:00+05:00",
                    end: "2025-08-01T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-564",
                    title: "Maple District Commons",
                    status: "completed",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-08-01T10:08:00+05:00",
                    end: "2025-08-01T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-565",
                    title: "Highland Greens",
                    status: "completed",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-08-01T11:01:00+05:00",
                    end: "2025-08-01T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-566",
                    title: "Casa Linda Enclave",
                    status: "completed",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-08-01T12:30:00+05:00",
                    end: "2025-08-01T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-567",
                    title: "Lakewood Gardens",
                    status: "completed",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-08-01T13:58:00+05:00",
                    end: "2025-08-01T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-568",
                    title: "Briarwood Villas",
                    status: "completed",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-08-01T14:46:00+05:00",
                    end: "2025-08-01T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-569",
                    title: "Oak Cliff Residences",
                    status: "completed",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-08-01T15:35:00+05:00",
                    end: "2025-08-01T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-570",
                    title: "Northwood Hills",
                    status: "completed",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-08-01T16:23:00+05:00",
                    end: "2025-08-01T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-571",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T17:58:00+05:00",
                    end: "2025-08-01T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-632",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "148636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-633",
                    title: "Mockingbird Plaza",
                    status: "completed",
                    startTime: "7:20 AM",
                    endTime: "3:01 PM",
                    address: "46124610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-08-01T07:20:00+05:00",
                    end: "2025-08-01T15:01:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-634",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "3:25 PM",
                    endTime: "3:55 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T15:25:00+05:00",
                    end: "2025-08-01T15:55:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  // current week
  {
    date: "2026-05-21",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-205",
                    title: "Evergreen's yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-206",
                    title: "Oak Crest Apartments",
                    status: "scheduled",
                    startTime: "7:42 AM",
                    endTime: "8:13 AM",
                    address: "3100 N Haskell Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20568",
                    start: "2025-07-28T07:42:00+05:00",
                    end: "2025-07-28T08:13:00+05:00",
                    origin: {
                      lat: 32.80968717938662,
                      lng: -96.79502553992131,
                    },
                    drive_time: "12",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-207",
                    title: "Maplewood Offices",
                    status: "scheduled",
                    startTime: "8:24 AM",
                    endTime: "8:49 AM",
                    address: "3936 Travis St, Dallas, TX",
                    contract: "Maintenance Agreement 20569",
                    start: "2025-07-28T08:24:00+05:00",
                    end: "2025-07-28T08:49:00+05:00",
                    origin: {
                      lat: 32.812420318228995,
                      lng: -96.79604852067472,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-208",
                    title: "Lakeside Retail Center",
                    status: "scheduled",
                    startTime: "8:59 AM",
                    endTime: "9:31 AM",
                    address: "4034a Buena Vista St, Dallas, TX",
                    contract: "Maintenance Agreement 20570",
                    start: "2025-07-28T08:59:00+05:00",
                    end: "2025-07-28T09:31:00+05:00",
                    origin: {
                      lat: 32.81436324549151,
                      lng: -96.79627887076978,
                    },
                    drive_time: "10",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-209",
                    title: "Pine Valley Townhomes",
                    status: "scheduled",
                    startTime: "9:39 AM",
                    endTime: "10:04 AM",
                    address: "4007 Stonebridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20571",
                    start: "2025-07-28T09:39:00+05:00",
                    end: "2025-07-28T10:04:00+05:00",
                    origin: {
                      lat: 32.81636202011015,
                      lng: -96.79676832281925,
                    },
                    drive_time: "8",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-210",
                    title: "Willowbrook Condo",
                    status: "scheduled",
                    startTime: "10:17 AM",
                    endTime: "10:42 AM",
                    address: "4136 Cole Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20572",
                    start: "2025-07-28T10:17:00+05:00",
                    end: "2025-07-28T10:42:00+05:00",
                    origin: {
                      lat: 32.81564916786807,
                      lng: -96.79247714923689,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-211",
                    title: "Elm Park Plaza",
                    status: "scheduled",
                    startTime: "10:51 AM",
                    endTime: "11:31 AM",
                    address: "4061 N Central Expy, Dallas, TX",
                    contract: "Maintenance Agreement 20573",
                    start: "2025-07-28T10:51:00+05:00",
                    end: "2025-07-28T11:31:00+05:00",
                    origin: {
                      lat: 32.81354908694805,
                      lng: -96.7912577014335,
                    },
                    drive_time: "9",
                    durationMinutes: 40,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-212",
                    title: "Cedar Ridge Village",
                    status: "scheduled",
                    startTime: "11:41 AM",
                    endTime: "12:14 PM",
                    address: "4114 N Central Expy, Dallas, TX",
                    contract: "Maintenance Agreement 20574",
                    start: "2025-07-28T11:41:00+05:00",
                    end: "2025-07-28T12:14:00+05:00",
                    origin: {
                      lat: 32.81313047201152,
                      lng: -96.7890222835907,
                    },
                    drive_time: "10",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-213",
                    title: "Birchwood Medical",
                    status: "scheduled",
                    startTime: "12:28 PM",
                    endTime: "12:53 PM",
                    address: "2802 N Carroll Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20575",
                    start: "2025-07-28T12:28:00+05:00",
                    end: "2025-07-28T12:53:00+05:00",
                    origin: {
                      lat: 32.811918200755336,
                      lng: -96.78875237948533,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-214",
                    title: "Dogwood Business Park",
                    status: "scheduled",
                    startTime: "1:05 PM",
                    endTime: "1:30 PM",
                    address:
                      "Birchwood Apartment Homes, 4829 Coles Manor Pl, Dallas, TX",
                    contract: "Maintenance Agreement 20576",
                    start: "2025-07-28T13:05:00+05:00",
                    end: "2025-07-28T13:30:00+05:00",
                    origin: {
                      lat: 32.812917201451604,
                      lng: -96.78566615676915,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-215",
                    title: "Magnolia Senior Living",
                    status: "scheduled",
                    startTime: "1:37 PM",
                    endTime: "2:09 PM",
                    address: "4319 Belmont Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20577",
                    start: "2025-07-28T13:37:00+05:00",
                    end: "2025-07-28T14:09:00+05:00",
                    origin: {
                      lat: 32.808547324041506,
                      lng: -96.78931852971077,
                    },
                    drive_time: "7",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-216",
                    title: "Aspen Heights School",
                    status: "scheduled",
                    startTime: "2:19 PM",
                    endTime: "2:44 PM",
                    address: "2409 N Henderson Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20578",
                    start: "2025-07-28T14:19:00+05:00",
                    end: "2025-07-28T14:44:00+05:00",
                    origin: {
                      lat: 32.815060654789114,
                      lng: -96.77892301199331,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-217",
                    title: "Sycamore Fitness Center",
                    status: "scheduled",
                    startTime: "2:57 PM",
                    endTime: "3:23 PM",
                    address: "7 McKinney Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20579",
                    start: "2025-07-28T14:57:00+05:00",
                    end: "2025-07-28T15:23:00+05:00",
                    origin: {
                      lat: 32.82044107805568,
                      lng: -96.78900343145571,
                    },
                    drive_time: "13",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-218",
                    title: "Juniper Villas",
                    status: "scheduled",
                    startTime: "3:34 PM",
                    endTime: "3:59 PM",
                    address: "3504 Overbrook Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20580",
                    start: "2025-07-28T15:34:00+05:00",
                    end: "2025-07-28T15:59:00+05:00",
                    origin: {
                      lat: 32.82045391775728,
                      lng: -96.79438485741689,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-219",
                    title: "Evergreen's yard",
                    status: "scheduled",
                    startTime: "3:59 PM",
                    endTime: "4:29 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T15:59:00+05:00",
                    end: "2025-07-28T16:29:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-030",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-23T07:00:00+05:00",
                    end: "2025-07-23T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "7",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-031",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "6900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-07-23T07:37:00+05:00",
                    end: "2025-07-23T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "7",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-032",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "3333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-07-23T08:40:00+05:00",
                    end: "2025-07-23T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-033",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "6550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-07-23T09:17:00+05:00",
                    end: "2025-07-23T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-034",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "6706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-07-23T09:54:00+05:00",
                    end: "2025-07-23T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "12",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-035",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "6723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-07-23T11:02:00+05:00",
                    end: "2025-07-23T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "20",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-036",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "6724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-07-23T11:56:00+05:00",
                    end: "2025-07-23T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "5",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-037",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "7015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-07-23T13:40:00+05:00",
                    end: "2025-07-23T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-038",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "5530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-07-23T14:23:00+05:00",
                    end: "2025-07-23T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "18",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-039",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-07-23T14:55:00+05:00",
                    end: "2025-07-23T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-040",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-23T15:20:00+05:00",
                    end: "2025-07-23T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-075",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "13",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-076",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "8:24 AM",
                    address: "3500 McDermott Rd, Plano, TX",
                    contract: "Enhancement Agreement 7535",
                    start: "2025-07-28T07:30:00+05:00",
                    end: "2025-07-28T08:24:00+05:00",
                    origin: {
                      lat: 33.09731135791416,
                      lng: -96.7561612900574,
                    },
                    drive_time: "13",
                    durationMinutes: 54,
                  },
                  {
                    id: "landscape_maintenance-visit-077",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "8:37 AM",
                    endTime: "10:15 AM",
                    address:
                      "Hendrick Football Fields, 7500 Red River Dr, Plano, TX",
                    contract: "Enhancement Agreement 1845",
                    start: "2025-07-28T08:37:00+05:00",
                    end: "2025-07-28T10:15:00+05:00",
                    origin: {
                      lat: 33.078958875996925,
                      lng: -96.72165675801857,
                    },
                    drive_time: "15",
                    durationMinutes: 98,
                  },
                  {
                    id: "landscape_maintenance-visit-078",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "10:30 AM",
                    endTime: "11:29 AM",
                    address: "Park Forest North, Plano, TX",
                    contract: "Enhancement Agreement 9636",
                    start: "2025-07-28T10:30:00+05:00",
                    end: "2025-07-28T11:29:00+05:00",
                    origin: {
                      lat: 33.06143375474646,
                      lng: -96.71594615605248,
                    },
                    drive_time: "7",
                    durationMinutes: 59,
                  },
                  {
                    id: "landscape_maintenance-visit-079",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "11:36 AM",
                    endTime: "12:26 PM",
                    address: "Horseshoe Park, 4012 Roundrock Trail, Plano, TX",
                    contract: "Enhancement Agreement 7326",
                    start: "2025-07-28T11:36:00+05:00",
                    end: "2025-07-28T12:26:00+05:00",
                    origin: {
                      lat: 33.05116383745358,
                      lng: -96.74307677041843,
                    },
                    drive_time: "20",
                    durationMinutes: 50,
                  },
                  {
                    id: "landscape_maintenance-visit-080",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "12:46 PM",
                    endTime: "1:58 PM",
                    address: "16 Preston Meadow Trail, Plano, TX",
                    contract: "Enhancement Agreement 7787",
                    start: "2025-07-28T12:46:00+05:00",
                    end: "2025-07-28T13:58:00+05:00",
                    origin: {
                      lat: 33.04736843936786,
                      lng: -96.77789681362674,
                    },
                    drive_time: "15",
                    durationMinutes: 72,
                  },
                  {
                    id: "landscape_maintenance-visit-081",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "2:14 PM",
                    endTime: "3:20 PM",
                    address: "6700 Archgate Dr, Plano, TX",
                    contract: "Enhancement Agreement 8492",
                    start: "2025-07-28T14:14:00+05:00",
                    end: "2025-07-28T15:20:00+05:00",
                    origin: {
                      lat: 33.061422515300954,
                      lng: -96.78223928424197,
                    },
                    drive_time: "15",
                    durationMinutes: 66,
                  },
                  {
                    id: "landscape_maintenance-visit-082",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:05 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T15:35:00+05:00",
                    end: "2025-07-28T16:05:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-635",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "248636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-636",
                    title: "Mockingbird Plaza",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "3:11 PM",
                    address: "46119610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-28T07:30:00+05:00",
                    end: "2025-07-28T15:11:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-637",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:30 PM",
                    endTime: "4:00 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T15:30:00+05:00",
                    end: "2025-07-28T16:00:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  // past day
  {
    date: "2026-05-19",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-220",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "8",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-221",
                    title: "Oakdale Senior Center",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "8:15 AM",
                    address: "5637 Hunters Bend Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20584",
                    start: "2025-07-29T07:40:00+05:00",
                    end: "2025-07-29T08:15:00+05:00",
                    origin: {
                      lat: 32.65537421687229,
                      lng: -96.97332544996381,
                    },
                    drive_time: "10",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-222",
                    title: "Brookstone Plaza",
                    status: "scheduled",
                    startTime: "8:26 AM",
                    endTime: "8:51 AM",
                    address: "5621 Bandit Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20585",
                    start: "2025-07-29T08:26:00+05:00",
                    end: "2025-07-29T08:51:00+05:00",
                    origin: {
                      lat: 32.65793132845956,
                      lng: -96.96997676403906,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-223",
                    title: "Elm Creek HOA",
                    status: "scheduled",
                    startTime: "8:57 AM",
                    endTime: "9:30 AM",
                    address: "5666 Mountain Hollow Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20586",
                    start: "2025-07-29T08:57:00+05:00",
                    end: "2025-07-29T09:30:00+05:00",
                    origin: {
                      lat: 32.65727746412962,
                      lng: -96.96548980363775,
                    },
                    drive_time: "6",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-224",
                    title: "Highland Commons",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:05 AM",
                    address: "5680 Centeridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20587",
                    start: "2025-07-29T09:37:00+05:00",
                    end: "2025-07-29T10:05:00+05:00",
                    origin: {
                      lat: 32.65848800584531,
                      lng: -96.96247565034557,
                    },
                    drive_time: "7",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-225",
                    title: "Briarwood Medical",
                    status: "scheduled",
                    startTime: "10:18 AM",
                    endTime: "10:43 AM",
                    address: "7917 Vista Hill Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20588",
                    start: "2025-07-29T10:18:00+05:00",
                    end: "2025-07-29T10:43:00+05:00",
                    origin: {
                      lat: 32.65588730116591,
                      lng: -96.96155785883717,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-226",
                    title: "Lakeview Apartments",
                    status: "scheduled",
                    startTime: "10:52 AM",
                    endTime: "11:23 AM",
                    address: "8635-8799 Granville Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20589",
                    start: "2025-07-29T10:52:00+05:00",
                    end: "2025-07-29T11:23:00+05:00",
                    origin: {
                      lat: 32.657329702530106,
                      lng: -96.95182588465576,
                    },
                    drive_time: "9",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-227",
                    title: "Whispering Pines Park",
                    status: "scheduled",
                    startTime: "11:33 AM",
                    endTime: "11:58 AM",
                    address: "8441 Clark Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20590",
                    start: "2025-07-29T11:33:00+05:00",
                    end: "2025-07-29T11:58:00+05:00",
                    origin: {
                      lat: 32.66098299324898,
                      lng: -96.94440557908295,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-228",
                    title: "Sunset Commercial Lot",
                    status: "scheduled",
                    startTime: "12:04 PM",
                    endTime: "12:29 PM",
                    address: "61407 W Ridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20591",
                    start: "2025-07-29T12:04:00+05:00",
                    end: "2025-07-29T12:29:00+05:00",
                    origin: {
                      lat: 32.656571503312556,
                      lng: -96.94134323823776,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-229",
                    title: "Orchard Villas",
                    status: "scheduled",
                    startTime: "12:41 PM",
                    endTime: "1:06 PM",
                    address: "6823 Cedar Forest Trail, Dallas, TX",
                    contract: "Maintenance Agreement 20592",
                    start: "2025-07-29T12:41:00+05:00",
                    end: "2025-07-29T13:06:00+05:00",
                    origin: {
                      lat: 32.664738578647075,
                      lng: -96.93503995031634,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-230",
                    title: "Linden Estates",
                    status: "scheduled",
                    startTime: "1:19 PM",
                    endTime: "1:49 PM",
                    address: "6927 Clarkridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20593",
                    start: "2025-07-29T13:19:00+05:00",
                    end: "2025-07-29T13:49:00+05:00",
                    origin: {
                      lat: 32.66781678212907,
                      lng: -96.9434105721135,
                    },
                    drive_time: "13",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-231",
                    title: "Redbud Office Center",
                    status: "scheduled",
                    startTime: "2:03 PM",
                    endTime: "2:35 PM",
                    address: "8303 Timberbrook Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20594",
                    start: "2025-07-29T14:03:00+05:00",
                    end: "2025-07-29T14:35:00+05:00",
                    origin: {
                      lat: 32.66542401234956,
                      lng: -96.95120340724914,
                    },
                    drive_time: "14",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-232",
                    title: "Windsor Hill Retail",
                    status: "scheduled",
                    startTime: "2:48 PM",
                    endTime: "3:13 PM",
                    address: "6640 Legters Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20595",
                    start: "2025-07-29T14:48:00+05:00",
                    end: "2025-07-29T15:13:00+05:00",
                    origin: {
                      lat: 32.667104262352105,
                      lng: -96.95313191395635,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-233",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "3:13 PM",
                    endTime: "3:43 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T15:13:00+05:00",
                    end: "2025-07-29T15:43:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-d-003",
                name: "LM 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-666",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T07:00:00+05:00",
                    end: "2025-07-22T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-667",
                    title: "Elm Grove Condos",
                    status: "scheduled",
                    startTime: "7:42 AM",
                    endTime: "8:10 AM",
                    address: "121234 Templecliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20613",
                    start: "2025-07-22T07:42:00+05:00",
                    end: "2025-07-22T08:10:00+05:00",
                    origin: {
                      lat: 32.73382673768448,
                      lng: -96.7039446,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-668",
                    title: "Lakewood Plaza",
                    status: "scheduled",
                    startTime: "8:20 AM",
                    endTime: "8:45 AM",
                    address: "101515 N Jim Miller Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20614",
                    start: "2025-07-22T08:20:00+05:00",
                    end: "2025-07-22T08:45:00+05:00",
                    origin: {
                      lat: 32.73939495440909,
                      lng: -96.70192221780633,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-669",
                    title: "Fair Oaks Retail",
                    status: "scheduled",
                    startTime: "8:54 AM",
                    endTime: "9:24 AM",
                    address: "96937 Umphress Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20615",
                    start: "2025-07-22T08:54:00+05:00",
                    end: "2025-07-22T09:24:00+05:00",
                    origin: {
                      lat: 32.74174537738961,
                      lng: -96.70189263337386,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-670",
                    title: "The Overlook HOA",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:02 AM",
                    address: "131703 Rocky Pl Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20616",
                    start: "2025-07-22T09:37:00+05:00",
                    end: "2025-07-22T10:02:00+05:00",
                    origin: {
                      lat: 32.74175237157451,
                      lng: -96.70101130412979,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-671",
                    title: "Brookstone Suites",
                    status: "scheduled",
                    startTime: "10:09 AM",
                    endTime: "10:34 AM",
                    address: "76902 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20617",
                    start: "2025-07-22T10:09:00+05:00",
                    end: "2025-07-22T10:34:00+05:00",
                    origin: {
                      lat: 32.742739134759965,
                      lng: -96.70301784305627,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-672",
                    title: "Hilltop Center",
                    status: "scheduled",
                    startTime: "10:42 AM",
                    endTime: "11:13 AM",
                    address: "86803 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20618",
                    start: "2025-07-22T10:42:00+05:00",
                    end: "2025-07-22T11:13:00+05:00",
                    origin: {
                      lat: 32.74326442753792,
                      lng: -96.70409202785368,
                    },
                    drive_time: "31",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-673",
                    title: "Westridge Medical",
                    status: "scheduled",
                    startTime: "11:22 AM",
                    endTime: "11:58 AM",
                    address: "91734 Eastcliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20619",
                    start: "2025-07-22T11:22:00+05:00",
                    end: "2025-07-22T11:58:00+05:00",
                    origin: {
                      lat: 32.74270897105405,
                      lng: -96.70594163276925,
                    },
                    drive_time: "36",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-674",
                    title: "Park Haven Offices",
                    status: "scheduled",
                    startTime: "12:10 PM",
                    endTime: "12:35 PM",
                    address: "126712-6798 Overpark Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20620",
                    start: "2025-07-22T12:10:00+05:00",
                    end: "2025-07-22T12:35:00+05:00",
                    origin: {
                      lat: 32.74158373926312,
                      lng: -96.70466253702625,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-675",
                    title: "Villas at Preston",
                    status: "scheduled",
                    startTime: "12:46 PM",
                    endTime: "1:16 PM",
                    address: "117015 Petty Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20621",
                    start: "2025-07-22T12:46:00+05:00",
                    end: "2025-07-22T13:16:00+05:00",
                    origin: {
                      lat: 32.744066518149474,
                      lng: -96.70195797501958,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-676",
                    title: "Creekside Townhomes",
                    status: "scheduled",
                    startTime: "1:29 PM",
                    endTime: "1:54 PM",
                    address: "137034 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20622",
                    start: "2025-07-22T13:29:00+05:00",
                    end: "2025-07-22T13:54:00+05:00",
                    origin: {
                      lat: 32.744552905644404,
                      lng: -96.7009760120773,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-677",
                    title: "Midway Business Hub",
                    status: "scheduled",
                    startTime: "2:01 PM",
                    endTime: "2:27 PM",
                    address: "76925 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20623",
                    start: "2025-07-22T14:01:00+05:00",
                    end: "2025-07-22T14:27:00+05:00",
                    origin: {
                      lat: 32.744964457415065,
                      lng: -96.7031389159949,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-678",
                    title: "Sunset Terrace",
                    status: "scheduled",
                    startTime: "2:33 PM",
                    endTime: "2:58 PM",
                    address: "62036 Earnhardt Way, Dallas, TX",
                    contract: "Maintenance Agreement 20624",
                    start: "2025-07-22T14:33:00+05:00",
                    end: "2025-07-22T14:58:00+05:00",
                    origin: {
                      lat: 32.74774466169055,
                      lng: -96.70055250157739,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-679",
                    title: "The Oaks HOA",
                    status: "scheduled",
                    startTime: "3:05 PM",
                    endTime: "3:38 PM",
                    address: "77120 Clearpoint Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20625",
                    start: "2025-07-22T15:05:00+05:00",
                    end: "2025-07-22T15:38:00+05:00",
                    origin: {
                      lat: 32.746171539123075,
                      lng: -96.69917866641367,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-680",
                    title: "Commerce Crossing",
                    status: "scheduled",
                    startTime: "3:48 PM",
                    endTime: "4:33 PM",
                    address: "101830 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20626",
                    start: "2025-07-22T15:48:00+05:00",
                    end: "2025-07-22T16:33:00+05:00",
                    origin: {
                      lat: 32.74388337540704,
                      lng: -96.69849674556865,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-681",
                    title: "Bluffview Estates",
                    status: "scheduled",
                    startTime: "4:42 PM",
                    endTime: "5:07 PM",
                    address: "91726 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20627",
                    start: "2025-07-22T16:42:00+05:00",
                    end: "2025-07-22T17:07:00+05:00",
                    origin: {
                      lat: 32.742733797171546,
                      lng: -96.69850949814688,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-682",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "5:07 PM",
                    endTime: "5:37 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T17:07:00+05:00",
                    end: "2025-07-22T17:37:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-c-002",
                name: "LM 3",
                crew_leader: "Miguel E.",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-710",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T07:00:00+05:00",
                    end: "2025-07-22T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-711",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-22T07:40:00+05:00",
                    end: "2025-07-22T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-712",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-22T09:08:00+05:00",
                    end: "2025-07-22T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-713",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-22T10:08:00+05:00",
                    end: "2025-07-22T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-714",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-22T11:01:00+05:00",
                    end: "2025-07-22T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-715",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-22T12:30:00+05:00",
                    end: "2025-07-22T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-716",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-22T13:58:00+05:00",
                    end: "2025-07-22T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-717",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-22T14:46:00+05:00",
                    end: "2025-07-22T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-718",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-22T15:35:00+05:00",
                    end: "2025-07-22T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-719",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-22T16:23:00+05:00",
                    end: "2025-07-22T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-720",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-22T17:15:00+05:00",
                    end: "2025-07-22T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-721",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T17:58:00+05:00",
                    end: "2025-07-22T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-d1-004",
                name: "LM 4",
                crew_leader: "William M.",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "William M.",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-750",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "158636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T07:00:00+05:00",
                    end: "2025-07-22T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-751",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "15771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-07-22T07:45:00+05:00",
                    end: "2025-07-22T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-752",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "155010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-07-22T08:45:00+05:00",
                    end: "2025-07-22T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-753",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "553 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-07-22T09:15:00+05:00",
                    end: "2025-07-22T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-754",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "205909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-07-22T10:00:00+05:00",
                    end: "2025-07-22T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-755",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-07-22T11:03:00+05:00",
                    end: "2025-07-22T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "34",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-756",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "20 Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-07-22T11:57:00+05:00",
                    end: "2025-07-22T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-757",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "20518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-07-22T12:42:00+05:00",
                    end: "2025-07-22T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "36",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-758",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-07-22T13:23:00+05:00",
                    end: "2025-07-22T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-759",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:03 PM",
                    endTime: "3:45 PM",
                    address: "15701 Royal Birkdale Dr, Dallas, TX",
                    contract: "Irrigation Service 9893",
                    start: "2025-07-22T14:03:00+05:00",
                    end: "2025-07-22T15:45:00+05:00",
                    origin: {
                      lat: 32.9735088764031,
                      lng: -96.63629889037135,
                    },
                    drive_time: "102",
                    durationMinutes: 102,
                  },
                  {
                    id: "landscape_maintenance-visit-760",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T15:45:00+05:00",
                    end: "2025-07-22T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-041",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-24T07:00:00+05:00",
                    end: "2025-07-24T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-042",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-07-24T07:45:00+05:00",
                    end: "2025-07-24T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "15",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-043",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "5010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-07-24T08:45:00+05:00",
                    end: "2025-07-24T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "15",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-044",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "533 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-07-24T09:15:00+05:00",
                    end: "2025-07-24T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "5",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-045",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "5909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-07-24T10:00:00+05:00",
                    end: "2025-07-24T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "20",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-046",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-07-24T11:03:00+05:00",
                    end: "2025-07-24T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "15",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-047",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-07-24T11:57:00+05:00",
                    end: "2025-07-24T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "20",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-048",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-07-24T12:42:00+05:00",
                    end: "2025-07-24T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "20",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-049",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-07-24T13:23:00+05:00",
                    end: "2025-07-24T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "5",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-050",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:03 PM",
                    endTime: "3:45 PM",
                    address: "15701 Royal Birkdale Dr, Dallas, TX",
                    contract: "Irrigation Service 9893",
                    start: "2025-07-24T14:03:00+05:00",
                    end: "2025-07-24T15:45:00+05:00",
                    origin: {
                      lat: 32.9735088764031,
                      lng: -96.63629889037135,
                    },
                    drive_time: "102",
                    durationMinutes: 102,
                  },
                  {
                    id: "landscape_maintenance-visit-051",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-24T15:45:00+05:00",
                    end: "2025-07-24T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-083",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "8",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-084",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "8:34 AM",
                    address: "8809 E 8th St, Ferris, TX",
                    contract: "Enhancement Agreement 6536",
                    start: "2025-07-29T07:30:00+05:00",
                    end: "2025-07-29T08:34:00+05:00",
                    origin: {
                      lat: 32.53275074286195,
                      lng: -96.65504813132146,
                    },
                    drive_time: "8",
                    durationMinutes: 64,
                  },
                  {
                    id: "landscape_maintenance-visit-085",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "8:42 AM",
                    endTime: "9:34 AM",
                    address: "456-498 Tall Oaks Ln, Ferris, TX",
                    contract: "Enhancement Agreement 3975",
                    start: "2025-07-29T08:42:00+05:00",
                    end: "2025-07-29T09:34:00+05:00",
                    origin: {
                      lat: 32.53894199341447,
                      lng: -96.65501920749496,
                    },
                    drive_time: "16",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-086",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "9:50 AM",
                    endTime: "10:46 AM",
                    address: "6605 N Fwy Service Rd, Ferris, TX",
                    contract: "Enhancement Agreement 5478",
                    start: "2025-07-29T09:50:00+05:00",
                    end: "2025-07-29T10:46:00+05:00",
                    origin: {
                      lat: 32.54059865262637,
                      lng: -96.6597315889924,
                    },
                    drive_time: "6",
                    durationMinutes: 56,
                  },
                  {
                    id: "landscape_maintenance-visit-087",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "10:52 AM",
                    endTime: "12:24 PM",
                    address: "8600-698 N Wood St, Ferris, TX",
                    contract: "Enhancement Agreement 2112",
                    start: "2025-07-29T10:52:00+05:00",
                    end: "2025-07-29T12:24:00+05:00",
                    origin: {
                      lat: 32.53985419972967,
                      lng: -96.66831017734886,
                    },
                    drive_time: "9",
                    durationMinutes: 92,
                  },
                  {
                    id: "landscape_maintenance-visit-088",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "12:32 PM",
                    endTime: "1:30 PM",
                    address: "5642-500 Meadowridge, Ferris, TX",
                    contract: "Enhancement Agreement 2932",
                    start: "2025-07-29T12:32:00+05:00",
                    end: "2025-07-29T13:30:00+05:00",
                    origin: {
                      lat: 32.53708650364146,
                      lng: -96.66970938236197,
                    },
                    drive_time: "58",
                    durationMinutes: 58,
                  },
                  {
                    id: "landscape_maintenance-visit-089",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "1:35 PM",
                    endTime: "2:20 PM",
                    address: "Ferris Memorial Park, 1000 Ferris Rd, Ferris, TX",
                    contract: "Enhancement Agreement 3342",
                    start: "2025-07-29T13:35:00+05:00",
                    end: "2025-07-29T14:20:00+05:00",
                    origin: {
                      lat: 32.540192832698814,
                      lng: -96.6768301908419,
                    },
                    drive_time: "7",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-090",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "2:27 PM",
                    endTime: "2:57 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T14:27:00+05:00",
                    end: "2025-07-29T14:57:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-d-003",
                name: "EN 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-786",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "68636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T07:00:00+05:00",
                    end: "2025-07-22T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-787",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "8:26 AM",
                    address:
                      "566 Luedeke Park, 3211 Hickory Tree Rd, Balch Springs, TX",
                    contract: "Enhancement Agreement 9146",
                    start: "2025-07-22T07:30:00+05:00",
                    end: "2025-07-22T08:26:00+05:00",
                    origin: {
                      lat: 32.72490505441594,
                      lng: -96.62671927834478,
                    },
                    drive_time: "56",
                    durationMinutes: 56,
                  },
                  {
                    id: "landscape_maintenance-visit-788",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "8:32 AM",
                    endTime: "11:14 AM",
                    address: "162142766-2706 Peachtree Rd, Balch Springs, TX",
                    contract: "Enhancement Agreement 1431",
                    start: "2025-07-22T08:32:00+05:00",
                    end: "2025-07-22T11:14:00+05:00",
                    origin: {
                      lat: 32.732227927637275,
                      lng: -96.6313313061763,
                    },
                    drive_time: "162",
                    durationMinutes: 162,
                  },
                  {
                    id: "landscape_maintenance-visit-789",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "11:28 AM",
                    endTime: "1:20 PM",
                    address: "11220 Edgemont Park, Mesquite, TX",
                    contract: "Enhancement Agreement 6386",
                    start: "2025-07-22T11:28:00+05:00",
                    end: "2025-07-22T13:20:00+05:00",
                    origin: {
                      lat: 32.745780688186954,
                      lng: -96.61801442761346,
                    },
                    drive_time: "112",
                    durationMinutes: 112,
                  },
                  {
                    id: "landscape_maintenance-visit-790",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "3:17 PM",
                    address: "971912722 Lake June Rd, Mesquite, TX",
                    contract: "Enhancement Agreement 9875",
                    start: "2025-07-22T13:40:00+05:00",
                    end: "2025-07-22T15:17:00+05:00",
                    origin: {
                      lat: 32.73700577891816,
                      lng: -96.60896302046001,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                  },
                  {
                    id: "landscape_maintenance-visit-791",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:36 PM",
                    endTime: "4:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T15:36:00+05:00",
                    end: "2025-07-22T16:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "CN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-638",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "248636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-639",
                    title: "Mockingbird Plaza",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "3:11 PM",
                    address: "46119610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-29T07:30:00+05:00",
                    end: "2025-07-29T15:11:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-640",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:30 PM",
                    endTime: "4:00 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T15:30:00+05:00",
                    end: "2025-07-29T16:00:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-d-003",
                name: "CN 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-817",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "348636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T07:00:00+05:00",
                    end: "2025-07-22T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-818",
                    title: "Silverbrook Heights",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "3:21 PM",
                    address: "461191225 Canton St, Dallas, TX",
                    contract: "Construction Project 6340",
                    start: "2025-07-22T07:40:00+05:00",
                    end: "2025-07-22T15:21:00+05:00",
                    origin: {
                      lat: 32.77363407835754,
                      lng: -96.79852861103222,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-819",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-22T15:40:00+05:00",
                    end: "2025-07-22T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  // Current Day
  {
    date: "2026-05-18",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-234",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "17",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-235",
                    title: "Shady Creek Offices",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:14 AM",
                    address: "4614 Kolloch Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20596",
                    start: "2025-07-30T07:37:00+05:00",
                    end: "2025-07-30T08:14:00+05:00",
                    origin: {
                      lat: 32.70505404900747,
                      lng: -96.75743760439987,
                    },
                    drive_time: "20",
                    durationMinutes: 37,
                  },
                  {
                    id: "landscape_maintenance-visit-236",
                    title: "Ridgepoint Plaza",
                    status: "completed",
                    startTime: "8:27 AM",
                    endTime: "8:52 AM",
                    address: "4420 Seay Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20597",
                    start: "2025-07-30T08:27:00+05:00",
                    end: "2025-07-30T08:52:00+05:00",
                    origin: {
                      lat: 32.70708247927941,
                      lng: -96.7652142,
                    },
                    drive_time: "20",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-237",
                    title: "Greenville Commons",
                    status: "completed",
                    startTime: "9:00 AM",
                    endTime: "9:35 AM",
                    address: "3617 Humphrey Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20598",
                    start: "2025-07-30T09:00:00+05:00",
                    end: "2025-07-30T09:35:00+05:00",
                    origin: {
                      lat: 32.718464624263355,
                      lng: -96.76801031405128,
                    },
                    drive_time: "26",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-238",
                    title: "Stonegate HOA",
                    status: "completed",
                    startTime: "9:41 AM",
                    endTime: "10:10 AM",
                    address: "3815 Cotton Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20599",
                    start: "2025-07-30T09:41:00+05:00",
                    end: "2025-07-30T10:10:00+05:00",
                    origin: {
                      lat: 32.72002758596667,
                      lng: -96.76145415406101,
                    },
                    drive_time: "32",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-239",
                    title: "Windsong Apartments",
                    status: "confirmation_pending",
                    startTime: "10:20 AM",
                    endTime: "10:53 AM",
                    address: "7921-7999 Carbondale St, Dallas, TX",
                    contract: "Maintenance Agreement 20600",
                    start: "2025-07-30T10:20:00+05:00",
                    end: "2025-07-30T10:53:00+05:00",
                    origin: {
                      lat: 32.71376474617464,
                      lng: -96.74906086416941,
                    },
                    drive_time: "22",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-240",
                    title: "Parkside Medical",
                    status: "confirmation_pending",
                    startTime: "11:05 AM",
                    endTime: "11:30 AM",
                    address: "4754 Zealand St, Dallas, TX",
                    contract: "Maintenance Agreement 20601",
                    start: "2025-07-30T11:05:00+05:00",
                    end: "2025-07-30T11:30:00+05:00",
                    origin: {
                      lat: 32.714879983513825,
                      lng: -96.74307330592717,
                    },
                    drive_time: "17",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-241",
                    title: "Fox Hollow Center",
                    status: "in_progress",
                    startTime: "11:37 AM",
                    endTime: "12:06 PM",
                    address: "4518 Cherbourg St, Dallas, TX",
                    contract: "Maintenance Agreement 20602",
                    start: "2025-07-30T11:37:00+05:00",
                    end: "2025-07-30T12:06:00+05:00",
                    origin: {
                      lat: 32.70755648337157,
                      lng: -96.74501779551147,
                    },
                    drive_time: "22",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-242",
                    title: "Rosefield Retail",
                    status: "scheduled",
                    startTime: "12:12 PM",
                    endTime: "12:37 PM",
                    address: "Pilgrim Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20603",
                    start: "2025-07-30T12:12:00+05:00",
                    end: "2025-07-30T12:37:00+05:00",
                    origin: {
                      lat: 32.743060479382805,
                      lng: -96.75275536918186,
                    },
                    drive_time: "20",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-243",
                    title: "Trailbend Estates",
                    status: "scheduled",
                    startTime: "12:50 PM",
                    endTime: "1:15 PM",
                    address: "2433 Scott St, Dallas, TX",
                    contract: "Maintenance Agreement 20604",
                    start: "2025-07-30T12:50:00+05:00",
                    end: "2025-07-30T13:15:00+05:00",
                    origin: {
                      lat: 32.743493138197465,
                      lng: -96.75446649462363,
                    },
                    drive_time: "19",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-244",
                    title: "Summit Commercial Park",
                    status: "scheduled",
                    startTime: "1:24 PM",
                    endTime: "1:57 PM",
                    address: "5701-5799 Sunday St, Dallas, TX",
                    contract: "Maintenance Agreement 20605",
                    start: "2025-07-30T13:24:00+05:00",
                    end: "2025-07-30T13:57:00+05:00",
                    origin: {
                      lat: 32.743121468155636,
                      lng: -96.756029891658,
                    },
                    drive_time: "18",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-245",
                    title: "Northwood Condos",
                    status: "scheduled",
                    startTime: "2:07 PM",
                    endTime: "2:32 PM",
                    address: "2313 Bethurum Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20606",
                    start: "2025-07-30T14:07:00+05:00",
                    end: "2025-07-30T14:32:00+05:00",
                    origin: {
                      lat: 32.74392955029714,
                      lng: -96.75610036468888,
                    },
                    drive_time: "21",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-246",
                    title: "Vantage Point Center",
                    status: "scheduled",
                    startTime: "2:43 PM",
                    endTime: "3:08 PM",
                    address: "2220 Hooper St, Dallas, TX",
                    contract: "Maintenance Agreement 20607",
                    start: "2025-07-30T14:43:00+05:00",
                    end: "2025-07-30T15:08:00+05:00",
                    origin: {
                      lat: 32.745206478954486,
                      lng: -96.75726338925523,
                    },
                    drive_time: "20",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-247",
                    title: "Lakehill Business Hub",
                    status: "scheduled",
                    startTime: "3:16 PM",
                    endTime: "3:45 PM",
                    address: "1699-1601 Faye St, Dallas, TX",
                    contract: "Maintenance Agreement 20608",
                    start: "2025-07-30T15:16:00+05:00",
                    end: "2025-07-30T15:45:00+05:00",
                    origin: {
                      lat: 32.74442339819566,
                      lng: -96.7585746070007,
                    },
                    drive_time: "26",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-248",
                    title: "Hillside Villas",
                    status: "scheduled",
                    startTime: "3:59 PM",
                    endTime: "4:24 PM",
                    address: "2483-2301 Anderson St, Dallas, TX",
                    contract: "Maintenance Agreement 20609",
                    start: "2025-07-30T15:59:00+05:00",
                    end: "2025-07-30T16:24:00+05:00",
                    origin: {
                      lat: 32.74571679880741,
                      lng: -96.75551282897112,
                    },
                    drive_time: "27",
                    durationMinutes: 25,
                  },
                  // {
                  //   id: "landscape_maintenance-visit-249",
                  //   title: "Skyline Estates",
                  //   status: "scheduled",
                  //   startTime: "4:31 PM",
                  //   endTime: "5:17 PM",
                  //   address: "72520-2598 Lowery St, Dallas, TX",
                  //   contract: "Maintenance Agreement 20610",
                  //   start: "2025-07-30T16:31:00+05:00",
                  //   end: "2025-07-30T17:17:00+05:00",
                  //   origin: {
                  //     lat: 32.74594196377146,
                  //     lng: -96.75423417961444,
                  //   },
                  //   drive_time: "7",
                  //   durationMinutes: 46,
                  // },
                  {
                    id: "landscape_maintenance-visit-250",
                    title: "Brookfield Shops",
                    status: "scheduled",
                    startTime: "5:26 PM",
                    endTime: "5:56 PM",
                    address: "92233 Macon St, Dallas, TX",
                    contract: "Maintenance Agreement 20611",
                    start: "2025-07-30T17:26:00+05:00",
                    end: "2025-07-30T17:56:00+05:00",
                    origin: {
                      lat: 32.747270379735575,
                      lng: -96.7578350620327,
                    },
                    drive_time: "33",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-251",
                    title: "Wheatland Townhomes",
                    status: "scheduled",
                    startTime: "6:05 PM",
                    endTime: "6:35 PM",
                    address: "3420-3612 Hancock St, Dallas, TX",
                    contract: "Maintenance Agreement 20612",
                    start: "2025-07-30T18:05:00+05:00",
                    end: "2025-07-30T18:35:00+05:00",
                    origin: {
                      lat: 32.76149199984842,
                      lng: -96.74355618650819,
                    },
                    drive_time: "22",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-252",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "6:35 PM",
                    endTime: "7:05 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T18:35:00+05:00",
                    end: "2025-07-30T19:05:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-d-003",
                name: "LM 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    punchedIn: "6:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-683",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T07:00:00+05:00",
                    end: "2025-07-23T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-684",
                    title: "Laurel Park Commons",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:06 AM",
                    address: "72200 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20628",
                    start: "2025-07-23T07:37:00+05:00",
                    end: "2025-07-23T08:06:00+05:00",
                    origin: {
                      lat: 32.82700062143119,
                      lng: -96.97545355404942,
                    },
                    drive_time: "15",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-685",
                    title: "Willowview HOA",
                    status: "completed",
                    startTime: "8:18 AM",
                    endTime: "8:44 AM",
                    address: "121603 Priscilla Ln, Irving, TX",
                    contract: "Maintenance Agreement 20629",
                    start: "2025-07-23T08:18:00+05:00",
                    end: "2025-07-23T08:44:00+05:00",
                    origin: {
                      lat: 32.83158778723434,
                      lng: -96.97103910479787,
                    },
                    drive_time: "15",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-686",
                    title: "The Branch Offices",
                    status: "confirmation_pending",
                    startTime: "8:52 AM",
                    endTime: "9:20 AM",
                    address: "81709 Green Oaks Dr, Irving, TX",
                    contract: "Maintenance Agreement 20630",
                    start: "2025-07-23T08:52:00+05:00",
                    end: "2025-07-23T09:20:00+05:00",
                    origin: {
                      lat: 32.832432887464925,
                      lng: -96.96678781110751,
                    },
                    drive_time: "15",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-687",
                    title: "Fox Hill Plaza",
                    status: "confirmation_pending",
                    startTime: "9:33 AM",
                    endTime: "10:06 AM",
                    address: "13267 W St Clair Dr, Irving, TX",
                    contract: "Maintenance Agreement 20631",
                    start: "2025-07-23T09:33:00+05:00",
                    end: "2025-07-23T10:06:00+05:00",
                    origin: {
                      lat: 32.82459779966745,
                      lng: -96.96212813072863,
                    },
                    drive_time: "15",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-688",
                    title: "Northaven Suites",
                    status: "in_progress",
                    startTime: "10:13 AM",
                    endTime: "10:38 AM",
                    address: "71311 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20632",
                    start: "2025-07-23T10:13:00+05:00",
                    end: "2025-07-23T10:38:00+05:00",
                    origin: {
                      lat: 32.81738323907385,
                      lng: -96.96163571966576,
                    },
                    drive_time: "15",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-689",
                    title: "Springridge Center",
                    status: "scheduled",
                    startTime: "10:48 AM",
                    endTime: "11:15 AM",
                    address: "101309 Limetree Ln, Irving, TX",
                    contract: "Maintenance Agreement 20633",
                    start: "2025-07-23T10:48:00+05:00",
                    end: "2025-07-23T11:15:00+05:00",
                    origin: {
                      lat: 32.82658243688681,
                      lng: -96.95362221982374,
                    },
                    drive_time: "15",
                    durationMinutes: 27,
                  },
                  {
                    id: "landscape_maintenance-visit-690",
                    title: "Midpark Towers",
                    status: "scheduled",
                    startTime: "11:20 AM",
                    endTime: "12:05 PM",
                    address: "51118 Brady Dr, Irving, TX",
                    contract: "Maintenance Agreement 20634",
                    start: "2025-07-23T11:20:00+05:00",
                    end: "2025-07-23T12:05:00+05:00",
                    origin: {
                      lat: 32.82671809190914,
                      lng: -96.94998831806257,
                    },
                    drive_time: "15",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-691",
                    title: "Cottonwood Villas",
                    status: "scheduled",
                    startTime: "12:13 PM",
                    endTime: "12:39 PM",
                    address: "81946 Shoaf Dr, Irving, TX",
                    contract: "Maintenance Agreement 20635",
                    start: "2025-07-23T12:13:00+05:00",
                    end: "2025-07-23T12:39:00+05:00",
                    origin: {
                      lat: 32.83422926324008,
                      lng: -96.94588238382623,
                    },
                    drive_time: "15",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-692",
                    title: "Valley Glen Retail",
                    status: "scheduled",
                    startTime: "12:45 PM",
                    endTime: "1:10 PM",
                    address: "62021 Shoaf Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20636",
                    start: "2025-07-23T12:45:00+05:00",
                    end: "2025-07-23T13:10:00+05:00",
                    origin: {
                      lat: 32.83518441521939,
                      lng: -96.94790165829477,
                    },
                    drive_time: "17",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-693",
                    title: "Hidden Creek Plaza",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "13122 W Holland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20637",
                    start: "2025-07-23T13:23:00+05:00",
                    end: "2025-07-23T13:48:00+05:00",
                    origin: {
                      lat: 32.83841754739589,
                      lng: -96.94561778664372,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-694",
                    title: "Ridgewood Shops",
                    status: "scheduled",
                    startTime: "1:55 PM",
                    endTime: "2:26 PM",
                    address: "72326 W Newton Cir, Dallas, TX",
                    contract: "Maintenance Agreement 20638",
                    start: "2025-07-23T13:55:00+05:00",
                    end: "2025-07-23T14:26:00+05:00",
                    origin: {
                      lat: 32.83931617496474,
                      lng: -96.94817451366447,
                    },
                    drive_time: "12",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-695",
                    title: "Southside Gardens",
                    status: "scheduled",
                    startTime: "2:37 PM",
                    endTime: "3:02 PM",
                    address: "112328 Brockbank Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20639",
                    start: "2025-07-23T14:37:00+05:00",
                    end: "2025-07-23T15:02:00+05:00",
                    origin: {
                      lat: 32.83917228935476,
                      lng: -96.94994426998946,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-696",
                    title: "The Gables at Oak",
                    status: "scheduled",
                    startTime: "3:16 PM",
                    endTime: "3:41 PM",
                    address: "14120 E Scotland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20640",
                    start: "2025-07-23T15:16:00+05:00",
                    end: "2025-07-23T15:41:00+05:00",
                    origin: {
                      lat: 32.840372057900865,
                      lng: -96.94357860432224,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-697",
                    title: "North Cliff Commons",
                    status: "scheduled",
                    startTime: "3:49 PM",
                    endTime: "4:36 PM",
                    address: "81403 English St, Dallas, TX",
                    contract: "Maintenance Agreement 20641",
                    start: "2025-07-23T15:49:00+05:00",
                    end: "2025-07-23T16:36:00+05:00",
                    origin: {
                      lat: 32.828681781644484,
                      lng: -96.93769216199404,
                    },
                    drive_time: "12",
                    durationMinutes: 47,
                  },
                  {
                    id: "landscape_maintenance-visit-698",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "4:36 PM",
                    endTime: "5:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T16:36:00+05:00",
                    end: "2025-07-23T17:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-c-002",
                name: "LM 3",
                crew_leader: "Miguel E.",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    punchedIn: "6:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-722",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T07:00:00+05:00",
                    end: "2025-07-23T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-723",
                    title: "Elm Grove Condos",
                    status: "completed",
                    startTime: "7:42 AM",
                    endTime: "8:10 AM",
                    address: "121234 Templecliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20613",
                    start: "2025-07-23T07:42:00+05:00",
                    end: "2025-07-23T08:10:00+05:00",
                    origin: {
                      lat: 32.73382673768448,
                      lng: -96.7039446,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-724",
                    title: "Lakewood Plaza",
                    status: "completed",
                    startTime: "8:20 AM",
                    endTime: "8:45 AM",
                    address: "101515 N Jim Miller Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20614",
                    start: "2025-07-23T08:20:00+05:00",
                    end: "2025-07-23T08:45:00+05:00",
                    origin: {
                      lat: 32.73939495440909,
                      lng: -96.70192221780633,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-725",
                    title: "Fair Oaks Retail",
                    status: "confirmation_pending",
                    startTime: "8:54 AM",
                    endTime: "9:24 AM",
                    address: "96937 Umphress Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20615",
                    start: "2025-07-23T08:54:00+05:00",
                    end: "2025-07-23T09:24:00+05:00",
                    origin: {
                      lat: 32.74174537738961,
                      lng: -96.70189263337386,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-726",
                    title: "The Overlook HOA",
                    status: "confirmation_pending",
                    startTime: "9:37 AM",
                    endTime: "10:02 AM",
                    address: "131703 Rocky Pl Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20616",
                    start: "2025-07-23T09:37:00+05:00",
                    end: "2025-07-23T10:02:00+05:00",
                    origin: {
                      lat: 32.74175237157451,
                      lng: -96.70101130412979,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-727",
                    title: "Brookstone Suites",
                    status: "in_progress",
                    startTime: "10:09 AM",
                    endTime: "10:34 AM",
                    address: "76902 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20617",
                    start: "2025-07-23T10:09:00+05:00",
                    end: "2025-07-23T10:34:00+05:00",
                    origin: {
                      lat: 32.742739134759965,
                      lng: -96.70301784305627,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-728",
                    title: "Hilltop Center",
                    status: "scheduled",
                    startTime: "10:42 AM",
                    endTime: "11:13 AM",
                    address: "86803 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20618",
                    start: "2025-07-23T10:42:00+05:00",
                    end: "2025-07-23T11:13:00+05:00",
                    origin: {
                      lat: 32.74326442753792,
                      lng: -96.70409202785368,
                    },
                    drive_time: "31",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-729",
                    title: "Westridge Medical",
                    status: "scheduled",
                    startTime: "11:22 AM",
                    endTime: "11:58 AM",
                    address: "91734 Eastcliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20619",
                    start: "2025-07-23T11:22:00+05:00",
                    end: "2025-07-23T11:58:00+05:00",
                    origin: {
                      lat: 32.74270897105405,
                      lng: -96.70594163276925,
                    },
                    drive_time: "36",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-730",
                    title: "Park Haven Offices",
                    status: "scheduled",
                    startTime: "12:10 PM",
                    endTime: "12:35 PM",
                    address: "126712-6798 Overpark Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20620",
                    start: "2025-07-23T12:10:00+05:00",
                    end: "2025-07-23T12:35:00+05:00",
                    origin: {
                      lat: 32.74158373926312,
                      lng: -96.70466253702625,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-731",
                    title: "Villas at Preston",
                    status: "scheduled",
                    startTime: "12:46 PM",
                    endTime: "1:16 PM",
                    address: "117015 Petty Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20621",
                    start: "2025-07-23T12:46:00+05:00",
                    end: "2025-07-23T13:16:00+05:00",
                    origin: {
                      lat: 32.744066518149474,
                      lng: -96.70195797501958,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-732",
                    title: "Creekside Townhomes",
                    status: "scheduled",
                    startTime: "1:29 PM",
                    endTime: "1:54 PM",
                    address: "137034 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20622",
                    start: "2025-07-23T13:29:00+05:00",
                    end: "2025-07-23T13:54:00+05:00",
                    origin: {
                      lat: 32.744552905644404,
                      lng: -96.7009760120773,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-733",
                    title: "Midway Business Hub",
                    status: "scheduled",
                    startTime: "2:01 PM",
                    endTime: "2:27 PM",
                    address: "76925 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20623",
                    start: "2025-07-23T14:01:00+05:00",
                    end: "2025-07-23T14:27:00+05:00",
                    origin: {
                      lat: 32.744964457415065,
                      lng: -96.7031389159949,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-734",
                    title: "Sunset Terrace",
                    status: "scheduled",
                    startTime: "2:33 PM",
                    endTime: "2:58 PM",
                    address: "62036 Earnhardt Way, Dallas, TX",
                    contract: "Maintenance Agreement 20624",
                    start: "2025-07-23T14:33:00+05:00",
                    end: "2025-07-23T14:58:00+05:00",
                    origin: {
                      lat: 32.74774466169055,
                      lng: -96.70055250157739,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-735",
                    title: "The Oaks HOA",
                    status: "scheduled",
                    startTime: "3:05 PM",
                    endTime: "3:38 PM",
                    address: "77120 Clearpoint Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20625",
                    start: "2025-07-23T15:05:00+05:00",
                    end: "2025-07-23T15:38:00+05:00",
                    origin: {
                      lat: 32.746171539123075,
                      lng: -96.69917866641367,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-736",
                    title: "Commerce Crossing",
                    status: "scheduled",
                    startTime: "3:48 PM",
                    endTime: "4:33 PM",
                    address: "101830 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20626",
                    start: "2025-07-23T15:48:00+05:00",
                    end: "2025-07-23T16:33:00+05:00",
                    origin: {
                      lat: 32.74388337540704,
                      lng: -96.69849674556865,
                    },
                    drive_time: "35",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-737",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "5:07 PM",
                    endTime: "5:37 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T17:07:00+05:00",
                    end: "2025-07-23T17:37:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-d1-004",
                name: "LM 4",
                crew_leader: "William M.",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    punchedIn: "6:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-761",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "78636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T07:00:00+05:00",
                    end: "2025-07-23T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-762",
                    title: "Eastwood HOA",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-07-23T07:37:00+05:00",
                    end: "2025-07-23T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-763",
                    title: "Bishop Arts Retail",
                    status: "completed",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-07-23T08:40:00+05:00",
                    end: "2025-07-23T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-764",
                    title: "Elmwood Bungalows",
                    status: "confirmation_pending",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-07-23T09:17:00+05:00",
                    end: "2025-07-23T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-765",
                    title: "Kessler Plaza",
                    status: "confirmation_pending",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-07-23T09:54:00+05:00",
                    end: "2025-07-23T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-766",
                    title: "Lakeside Apartments",
                    status: "in_progress",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-07-23T11:02:00+05:00",
                    end: "2025-07-23T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "49",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-767",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-07-23T11:56:00+05:00",
                    end: "2025-07-23T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-768",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-07-23T13:40:00+05:00",
                    end: "2025-07-23T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-769",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-07-23T14:23:00+05:00",
                    end: "2025-07-23T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-770",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "7 Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-07-23T14:55:00+05:00",
                    end: "2025-07-23T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-771",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T15:20:00+05:00",
                    end: "2025-07-23T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    punchedIn: "6:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                    punchedIn: "6:59 AM",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-052",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-25T07:00:00+05:00",
                    end: "2025-07-25T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "17",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-053",
                    title: "Rosemont HOA",
                    status: "confirmation_pending",
                    startTime: "7:47 AM",
                    endTime: "10:02 AM",
                    address: "501 Breneman St, Hutchins, TX",
                    contract: "Irrigation Service 3767",
                    start: "2025-07-25T07:47:00+05:00",
                    end: "2025-07-25T10:02:00+05:00",
                    origin: {
                      lat: 32.64409133922338,
                      lng: -96.7147154240649,
                    },
                    drive_time: "135",
                    durationMinutes: 135,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-054",
                    title: "Eastwood HOA",
                    status: "confirmation_pending",
                    startTime: "10:20 AM",
                    endTime: "11:15 AM",
                    address: "409 W Dallas St, Mesquite, TX",
                    contract: "Irrigation Service 6359",
                    start: "2025-07-25T10:20:00+05:00",
                    end: "2025-07-25T11:15:00+05:00",
                    origin: {
                      lat: 32.64909613267304,
                      lng: -96.71752014015009,
                    },
                    drive_time: "18",
                    durationMinutes: 55,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-055",
                    title: "Lakeside Apartments",
                    status: "in_progress",
                    startTime: "11:24 AM",
                    endTime: "12:16 PM",
                    address: "9353 N Fwy Service Rd, Mesquite, TX",
                    contract: "Irrigation Service 4626",
                    start: "2025-07-25T11:24:00+05:00",
                    end: "2025-07-25T12:16:00+05:00",
                    origin: {
                      lat: 32.645285374478675,
                      lng: -96.70676960603262,
                    },
                    drive_time: "9",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-056",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "12:31 PM",
                    endTime: "12:56 PM",
                    address: "300 N Fwy Service Rd, Irving, TX",
                    contract: "Irrigation Service 7747",
                    start: "2025-07-25T12:31:00+05:00",
                    end: "2025-07-25T12:56:00+05:00",
                    origin: {
                      lat: 32.64619686410966,
                      lng: -96.70538933228508,
                    },
                    drive_time: "15",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-057",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "1:13 PM",
                    endTime: "1:38 PM",
                    address: "1101 E Cleveland St, Irving, TX",
                    contract: "Irrigation Service 3191",
                    start: "2025-07-25T13:13:00+05:00",
                    end: "2025-07-25T13:38:00+05:00",
                    origin: {
                      lat: 32.65679013311816,
                      lng: -96.70690950356153,
                    },
                    drive_time: "17",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-058",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "1:44 PM",
                    endTime: "2:34 PM",
                    address: "6309 Nichols Dr, Dallas, TX",
                    contract: "Irrigation Service 9157",
                    start: "2025-07-25T13:44:00+05:00",
                    end: "2025-07-25T14:34:00+05:00",
                    origin: {
                      lat: 32.65278443140102,
                      lng: -96.69506327512997,
                    },
                    drive_time: "6",
                    durationMinutes: 50,
                  },
                  {
                    id: "landscape_maintenance-visit-059",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "2:52 PM",
                    endTime: "3:38 PM",
                    address: "1506 E Langdon Rd, Dallas, TX",
                    contract: "Irrigation Service 3630",
                    start: "2025-07-25T14:52:00+05:00",
                    end: "2025-07-25T15:38:00+05:00",
                    origin: {
                      lat: 32.663336441970046,
                      lng: -96.71770660910384,
                    },
                    drive_time: "18",
                    durationMinutes: 46,
                  },
                  {
                    id: "landscape_maintenance-visit-060",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:38 PM",
                    endTime: "4:08 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-25T15:38:00+05:00",
                    end: "2025-07-25T16:08:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-091",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "17",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-092",
                    title: "Uptown Grove",
                    status: "confirmation_pending",
                    startTime: "7:30 AM",
                    endTime: "9:19 AM",
                    address: "1739 Doubletree Pl, Sunnyvale, TX",
                    contract: "Enhancement Agreement 9160",
                    start: "2025-07-30T07:30:00+05:00",
                    end: "2025-07-30T09:19:00+05:00",
                    origin: {
                      lat: 32.77917161153209,
                      lng: -96.5716917507517,
                    },
                    drive_time: "109",
                    durationMinutes: 109,
                  },
                  {
                    id: "landscape_maintenance-visit-093",
                    title: "Oak Cliff Residences",
                    status: "confirmation_pending",
                    startTime: "9:36 AM",
                    endTime: "11:48 AM",
                    address: "116 Lakeview Dr, Sunnyvale, TX",
                    contract: "Enhancement Agreement 2009",
                    start: "2025-07-30T09:36:00+05:00",
                    end: "2025-07-30T11:48:00+05:00",
                    origin: {
                      lat: 32.79098555450635,
                      lng: -96.5738275251745,
                    },
                    drive_time: "132",
                    durationMinutes: 132,
                  },
                  {
                    id: "landscape_maintenance-visit-094",
                    title: "Briarwood Villas",
                    status: "in_progress",
                    startTime: "11:58 AM",
                    endTime: "1:27 PM",
                    address: "200 Collins Rd, Sunnyvale, TX",
                    contract: "Enhancement Agreement 9490",
                    start: "2025-07-30T11:58:00+05:00",
                    end: "2025-07-30T13:27:00+05:00",
                    origin: {
                      lat: 32.79239922256162,
                      lng: -96.56174251216447,
                    },
                    drive_time: "89",
                    durationMinutes: 89,
                  },
                  {
                    id: "landscape_maintenance-visit-095",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "1:45 PM",
                    endTime: "3:09 PM",
                    address:
                      "Samuell New Hope Park Site, 100 Town E Blvd, Mesquite, TX",
                    contract: "Enhancement Agreement 5193",
                    start: "2025-07-30T13:45:00+05:00",
                    end: "2025-07-30T15:09:00+05:00",
                    origin: {
                      lat: 32.80878050597,
                      lng: -96.59032767818985,
                    },
                    drive_time: "84",
                    durationMinutes: 84,
                  },
                  {
                    id: "landscape_maintenance-visit-096",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:15 PM",
                    endTime: "3:45 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T15:15:00+05:00",
                    end: "2025-07-30T15:45:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-d-003",
                name: "EN 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-792",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T07:00:00+05:00",
                    end: "2025-07-23T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-793",
                    title: "Preston Hollow Estates",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-23T07:40:00+05:00",
                    end: "2025-07-23T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-794",
                    title: "Park Lane Terraces",
                    status: "confirmation_pending",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-23T09:08:00+05:00",
                    end: "2025-07-23T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-795",
                    title: "Maple District Commons",
                    status: "confirmation_pending",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-23T10:08:00+05:00",
                    end: "2025-07-23T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-796",
                    title: "Highland Greens",
                    status: "in_progress",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-23T11:01:00+05:00",
                    end: "2025-07-23T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-797",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-23T12:30:00+05:00",
                    end: "2025-07-23T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-798",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-23T13:58:00+05:00",
                    end: "2025-07-23T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-799",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-23T14:46:00+05:00",
                    end: "2025-07-23T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-800",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-23T15:35:00+05:00",
                    end: "2025-07-23T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-801",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-23T16:23:00+05:00",
                    end: "2025-07-23T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-802",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T17:58:00+05:00",
                    end: "2025-07-23T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "CN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-641",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "248636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-642",
                    title: "Mockingbird Plaza",
                    status: "in_progress",
                    startTime: "7:30 AM",
                    endTime: "3:11 PM",
                    address: "46119610 S Rogers Rd, Irving, TX",
                    contract: "Construction Project 6339",
                    start: "2025-07-30T07:30:00+05:00",
                    end: "2025-07-30T15:11:00+05:00",
                    origin: {
                      lat: 32.80820804007538,
                      lng: -96.96272526468876,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-643",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:30 PM",
                    endTime: "4:00 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T15:30:00+05:00",
                    end: "2025-07-30T16:00:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-d-003",
                name: "CN 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-820",
                    title: "Evergreen’s Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "148636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T07:00:00+05:00",
                    end: "2025-07-23T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-821",
                    title: "Silverbrook Heights",
                    status: "confirmation_pending",
                    startTime: "7:44 AM",
                    endTime: "1:24 PM",
                    address: "340181225 Canton St, Dallas, TX",
                    contract: "Construction Project 6340",
                    start: "2025-07-23T07:44:00+05:00",
                    end: "2025-07-23T13:24:00+05:00",
                    origin: {
                      lat: 32.77363407835754,
                      lng: -96.79852861103222,
                    },
                    drive_time: "340",
                    durationMinutes: 340,
                  },
                  {
                    id: "landscape_maintenance-visit-822",
                    title: "Crystal Ridge",
                    status: "in_progress",
                    startTime: "1:42 PM",
                    endTime: "3:25 PM",
                    address: "103145201-5299 Black Hawk St, Dallas, TX",
                    contract: "Construction Project 6341",
                    start: "2025-07-23T13:42:00+05:00",
                    end: "2025-07-23T15:25:00+05:00",
                    origin: {
                      lat: 32.767623063110356,
                      lng: -96.90407836468884,
                    },
                    drive_time: "103",
                    durationMinutes: 103,
                  },
                  {
                    id: "landscape_maintenance-visit-823",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:39 PM",
                    endTime: "4:09 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-23T15:39:00+05:00",
                    end: "2025-07-23T16:09:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-20",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-253",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-254",
                    title: "Elm Grove Condos",
                    status: "scheduled",
                    startTime: "7:42 AM",
                    endTime: "8:10 AM",
                    address: "121234 Templecliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20613",
                    start: "2025-07-31T07:42:00+05:00",
                    end: "2025-07-31T08:10:00+05:00",
                    origin: {
                      lat: 32.73382673768448,
                      lng: -96.7039446,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-255",
                    title: "Lakewood Plaza",
                    status: "scheduled",
                    startTime: "8:20 AM",
                    endTime: "8:45 AM",
                    address: "101515 N Jim Miller Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20614",
                    start: "2025-07-31T08:20:00+05:00",
                    end: "2025-07-31T08:45:00+05:00",
                    origin: {
                      lat: 32.73939495440909,
                      lng: -96.70192221780633,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-256",
                    title: "Fair Oaks Retail",
                    status: "scheduled",
                    startTime: "8:54 AM",
                    endTime: "9:24 AM",
                    address: "96937 Umphress Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20615",
                    start: "2025-07-31T08:54:00+05:00",
                    end: "2025-07-31T09:24:00+05:00",
                    origin: {
                      lat: 32.74174537738961,
                      lng: -96.70189263337386,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-257",
                    title: "The Overlook HOA",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:02 AM",
                    address: "131703 Rocky Pl Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20616",
                    start: "2025-07-31T09:37:00+05:00",
                    end: "2025-07-31T10:02:00+05:00",
                    origin: {
                      lat: 32.74175237157451,
                      lng: -96.70101130412979,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-258",
                    title: "Brookstone Suites",
                    status: "scheduled",
                    startTime: "10:09 AM",
                    endTime: "10:34 AM",
                    address: "76902 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20617",
                    start: "2025-07-31T10:09:00+05:00",
                    end: "2025-07-31T10:34:00+05:00",
                    origin: {
                      lat: 32.742739134759965,
                      lng: -96.70301784305627,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-259",
                    title: "Hilltop Center",
                    status: "scheduled",
                    startTime: "10:42 AM",
                    endTime: "11:13 AM",
                    address: "86803 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20618",
                    start: "2025-07-31T10:42:00+05:00",
                    end: "2025-07-31T11:13:00+05:00",
                    origin: {
                      lat: 32.74326442753792,
                      lng: -96.70409202785368,
                    },
                    drive_time: "8",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-260",
                    title: "Westridge Medical",
                    status: "scheduled",
                    startTime: "11:22 AM",
                    endTime: "11:58 AM",
                    address: "91734 Eastcliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20619",
                    start: "2025-07-31T11:22:00+05:00",
                    end: "2025-07-31T11:58:00+05:00",
                    origin: {
                      lat: 32.74270897105405,
                      lng: -96.70594163276925,
                    },
                    drive_time: "9",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-261",
                    title: "Park Haven Offices",
                    status: "scheduled",
                    startTime: "12:10 PM",
                    endTime: "12:35 PM",
                    address: "6712-6798 Overpark Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20620",
                    start: "2025-07-31T12:10:00+05:00",
                    end: "2025-07-31T12:35:00+05:00",
                    origin: {
                      lat: 32.74158373926312,
                      lng: -96.70466253702625,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-262",
                    title: "Villas at Preston",
                    status: "scheduled",
                    startTime: "12:46 PM",
                    endTime: "1:16 PM",
                    address: "7015 Petty Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20621",
                    start: "2025-07-31T12:46:00+05:00",
                    end: "2025-07-31T13:16:00+05:00",
                    origin: {
                      lat: 32.744066518149474,
                      lng: -96.70195797501958,
                    },
                    drive_time: "11",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-263",
                    title: "Creekside Townhomes",
                    status: "scheduled",
                    startTime: "1:29 PM",
                    endTime: "1:54 PM",
                    address: "7034 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20622",
                    start: "2025-07-31T13:29:00+05:00",
                    end: "2025-07-31T13:54:00+05:00",
                    origin: {
                      lat: 32.744552905644404,
                      lng: -96.7009760120773,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-264",
                    title: "Midway Business Hub",
                    status: "scheduled",
                    startTime: "2:01 PM",
                    endTime: "2:27 PM",
                    address: "76925 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20623",
                    start: "2025-07-31T14:01:00+05:00",
                    end: "2025-07-31T14:27:00+05:00",
                    origin: {
                      lat: 32.744964457415065,
                      lng: -96.7031389159949,
                    },
                    drive_time: "7",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-265",
                    title: "Sunset Terrace",
                    status: "scheduled",
                    startTime: "2:33 PM",
                    endTime: "2:58 PM",
                    address: "62036 Earnhardt Way, Dallas, TX",
                    contract: "Maintenance Agreement 20624",
                    start: "2025-07-31T14:33:00+05:00",
                    end: "2025-07-31T14:58:00+05:00",
                    origin: {
                      lat: 32.74774466169055,
                      lng: -96.70055250157739,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-266",
                    title: "The Oaks HOA",
                    status: "scheduled",
                    startTime: "3:05 PM",
                    endTime: "3:38 PM",
                    address: "77120 Clearpoint Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20625",
                    start: "2025-07-31T15:05:00+05:00",
                    end: "2025-07-31T15:38:00+05:00",
                    origin: {
                      lat: 32.746171539123075,
                      lng: -96.69917866641367,
                    },
                    drive_time: "7",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-267",
                    title: "Commerce Crossing",
                    status: "scheduled",
                    startTime: "3:48 PM",
                    endTime: "4:33 PM",
                    address: "101830 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20626",
                    start: "2025-07-31T15:48:00+05:00",
                    end: "2025-07-31T16:33:00+05:00",
                    origin: {
                      lat: 32.74388337540704,
                      lng: -96.69849674556865,
                    },
                    drive_time: "10",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-268",
                    title: "Bluffview Estates",
                    status: "scheduled",
                    startTime: "4:42 PM",
                    endTime: "5:07 PM",
                    address: "91726 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20627",
                    start: "2025-07-31T16:42:00+05:00",
                    end: "2025-07-31T17:07:00+05:00",
                    origin: {
                      lat: 32.742733797171546,
                      lng: -96.69850949814688,
                    },
                    drive_time: "9",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-269",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "5:07 PM",
                    endTime: "5:37 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T17:07:00+05:00",
                    end: "2025-07-31T17:37:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-d-003",
                name: "LM 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-699",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "78636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T07:00:00+05:00",
                    end: "2025-07-24T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-700",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-07-24T07:37:00+05:00",
                    end: "2025-07-24T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-701",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-07-24T08:40:00+05:00",
                    end: "2025-07-24T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-702",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-07-24T09:17:00+05:00",
                    end: "2025-07-24T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-703",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-07-24T09:54:00+05:00",
                    end: "2025-07-24T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-704",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-07-24T11:02:00+05:00",
                    end: "2025-07-24T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "49",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-705",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-07-24T11:56:00+05:00",
                    end: "2025-07-24T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-706",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-07-24T13:40:00+05:00",
                    end: "2025-07-24T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-707",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-07-24T14:23:00+05:00",
                    end: "2025-07-24T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-708",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "7 Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-07-24T14:55:00+05:00",
                    end: "2025-07-24T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-709",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T15:20:00+05:00",
                    end: "2025-07-24T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-c-002",
                name: "LM 3",
                crew_leader: "Miguel E.",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-738",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T07:00:00+05:00",
                    end: "2025-07-24T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-739",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-24T07:40:00+05:00",
                    end: "2025-07-24T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-740",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-24T09:08:00+05:00",
                    end: "2025-07-24T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-741",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-24T10:08:00+05:00",
                    end: "2025-07-24T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-742",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-24T11:01:00+05:00",
                    end: "2025-07-24T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-743",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-24T12:30:00+05:00",
                    end: "2025-07-24T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-744",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-24T13:58:00+05:00",
                    end: "2025-07-24T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-745",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-24T14:46:00+05:00",
                    end: "2025-07-24T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-746",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-24T15:35:00+05:00",
                    end: "2025-07-24T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-747",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-24T16:23:00+05:00",
                    end: "2025-07-24T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-748",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-24T17:15:00+05:00",
                    end: "2025-07-24T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-749",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T17:58:00+05:00",
                    end: "2025-07-24T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-d1-004",
                name: "LM 4",
                crew_leader: "William M.",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "John Ferris",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-772",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "88636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T07:00:00+05:00",
                    end: "2025-07-24T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-773",
                    title: "Oakdale Senior Center",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "8:15 AM",
                    address: "35105637 Hunters Bend Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20584",
                    start: "2025-07-24T07:40:00+05:00",
                    end: "2025-07-24T08:15:00+05:00",
                    origin: {
                      lat: 32.65537421687229,
                      lng: -96.97332544996381,
                    },
                    drive_time: "35",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-774",
                    title: "Brookstone Plaza",
                    status: "scheduled",
                    startTime: "8:26 AM",
                    endTime: "8:51 AM",
                    address: "25115621 Bandit Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20585",
                    start: "2025-07-24T08:26:00+05:00",
                    end: "2025-07-24T08:51:00+05:00",
                    origin: {
                      lat: 32.65793132845956,
                      lng: -96.96997676403906,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-775",
                    title: "Elm Creek HOA",
                    status: "scheduled",
                    startTime: "8:57 AM",
                    endTime: "9:30 AM",
                    address: "3365666 Mountain Hollow Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20586",
                    start: "2025-07-24T08:57:00+05:00",
                    end: "2025-07-24T09:30:00+05:00",
                    origin: {
                      lat: 32.65727746412962,
                      lng: -96.96548980363775,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-776",
                    title: "Highland Commons",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:05 AM",
                    address: "2875680 Centeridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20587",
                    start: "2025-07-24T09:37:00+05:00",
                    end: "2025-07-24T10:05:00+05:00",
                    origin: {
                      lat: 32.65848800584531,
                      lng: -96.96247565034557,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-777",
                    title: "Briarwood Medical",
                    status: "scheduled",
                    startTime: "10:18 AM",
                    endTime: "10:43 AM",
                    address: "25137917 Vista Hill Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20588",
                    start: "2025-07-24T10:18:00+05:00",
                    end: "2025-07-24T10:43:00+05:00",
                    origin: {
                      lat: 32.65588730116591,
                      lng: -96.96155785883717,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-778",
                    title: "Lakeview Apartments",
                    status: "scheduled",
                    startTime: "10:52 AM",
                    endTime: "11:23 AM",
                    address: "3198635-8799 Granville Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20589",
                    start: "2025-07-24T10:52:00+05:00",
                    end: "2025-07-24T11:23:00+05:00",
                    origin: {
                      lat: 32.657329702530106,
                      lng: -96.95182588465576,
                    },
                    drive_time: "31",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-779",
                    title: "Whispering Pines Park",
                    status: "scheduled",
                    startTime: "11:33 AM",
                    endTime: "11:58 AM",
                    address: "25108441 Clark Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20590",
                    start: "2025-07-24T11:33:00+05:00",
                    end: "2025-07-24T11:58:00+05:00",
                    origin: {
                      lat: 32.66098299324898,
                      lng: -96.94440557908295,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-780",
                    title: "Sunset Commercial Lot",
                    status: "scheduled",
                    startTime: "12:04 PM",
                    endTime: "12:29 PM",
                    address: "2561407 W Ridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20591",
                    start: "2025-07-24T12:04:00+05:00",
                    end: "2025-07-24T12:29:00+05:00",
                    origin: {
                      lat: 32.656571503312556,
                      lng: -96.94134323823776,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-781",
                    title: "Orchard Villas",
                    status: "scheduled",
                    startTime: "12:41 PM",
                    endTime: "1:06 PM",
                    address: "25126823 Cedar Forest Trail, Dallas, TX",
                    contract: "Maintenance Agreement 20592",
                    start: "2025-07-24T12:41:00+05:00",
                    end: "2025-07-24T13:06:00+05:00",
                    origin: {
                      lat: 32.664738578647075,
                      lng: -96.93503995031634,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-782",
                    title: "Linden Estates",
                    status: "scheduled",
                    startTime: "1:19 PM",
                    endTime: "1:49 PM",
                    address: "30136927 Clarkridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20593",
                    start: "2025-07-24T13:19:00+05:00",
                    end: "2025-07-24T13:49:00+05:00",
                    origin: {
                      lat: 32.66781678212907,
                      lng: -96.9434105721135,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-783",
                    title: "Redbud Office Center",
                    status: "scheduled",
                    startTime: "2:03 PM",
                    endTime: "2:35 PM",
                    address: "32148303 Timberbrook Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20594",
                    start: "2025-07-24T14:03:00+05:00",
                    end: "2025-07-24T14:35:00+05:00",
                    origin: {
                      lat: 32.66542401234956,
                      lng: -96.95120340724914,
                    },
                    drive_time: "32",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-784",
                    title: "Windsor Hill Retail",
                    status: "scheduled",
                    startTime: "2:48 PM",
                    endTime: "3:13 PM",
                    address: "25136640 Legters Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20595",
                    start: "2025-07-24T14:48:00+05:00",
                    end: "2025-07-24T15:13:00+05:00",
                    origin: {
                      lat: 32.667104262352105,
                      lng: -96.95313191395635,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-785",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "3:13 PM",
                    endTime: "3:43 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T15:13:00+05:00",
                    end: "2025-07-24T15:43:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-061",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-26T07:00:00+05:00",
                    end: "2025-07-26T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-062",
                    title: "Willow Creek HOA",
                    status: "scheduled",
                    startTime: "7:47 AM",
                    endTime: "9:24 AM",
                    address: "3209 Chapel Downs Dr, Dallas, TX",
                    contract: "Irrigation Service 5741",
                    start: "2025-07-26T07:47:00+05:00",
                    end: "2025-07-26T09:24:00+05:00",
                    origin: {
                      lat: 32.88505710797178,
                      lng: -96.86886593120309,
                    },
                    drive_time: "17",
                    durationMinutes: 97,
                  },
                  {
                    id: "landscape_maintenance-visit-063",
                    title: "Preston Oaks Apartments",
                    status: "scheduled",
                    startTime: "9:44 AM",
                    endTime: "10:44 AM",
                    address: "3445 Evening Petal Ln, Dallas, TX",
                    contract: "Irrigation Service 2307",
                    start: "2025-07-26T09:44:00+05:00",
                    end: "2025-07-26T10:44:00+05:00",
                    origin: {
                      lat: 32.884834145189366,
                      lng: -96.86451098999343,
                    },
                    drive_time: "20",
                    durationMinutes: 60,
                  },
                  {
                    id: "landscape_maintenance-visit-064",
                    title: "Maplewood Residence",
                    status: "scheduled",
                    startTime: "10:55 AM",
                    endTime: "11:20 AM",
                    address: "3491 Timberview Rd, Dallas, TX",
                    contract: "Irrigation Service 4814",
                    start: "2025-07-26T10:55:00+05:00",
                    end: "2025-07-26T11:20:00+05:00",
                    origin: {
                      lat: 32.88550216125378,
                      lng: -96.86257012055738,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-065",
                    title: "Royal Lane Retail",
                    status: "scheduled",
                    startTime: "11:36 AM",
                    endTime: "2:06 PM",
                    address: "10306 Countess Dr, Dallas, TX",
                    contract: "Irrigation Service 2654",
                    start: "2025-07-26T11:36:00+05:00",
                    end: "2025-07-26T14:06:00+05:00",
                    origin: {
                      lat: 32.88641983572525,
                      lng: -96.86356685252409,
                    },
                    drive_time: "16",
                    durationMinutes: 150,
                  },
                  {
                    id: "landscape_maintenance-visit-066",
                    title: "Lake Highlands Estate",
                    status: "scheduled",
                    startTime: "2:17 PM",
                    endTime: "3:04 PM",
                    address: "3436 Webb Garden Dr, Dallas, TX",
                    contract: "Irrigation Service 7227",
                    start: "2025-07-26T14:17:00+05:00",
                    end: "2025-07-26T15:04:00+05:00",
                    origin: {
                      lat: 32.882916363159595,
                      lng: -96.86494119306573,
                    },
                    drive_time: "11",
                    durationMinutes: 47,
                  },
                  {
                    id: "landscape_maintenance-visit-067",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:04 PM",
                    endTime: "3:34 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-26T15:04:00+05:00",
                    end: "2025-07-26T15:34:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-097",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "6",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-098",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "8:26 AM",
                    address:
                      "Luedeke Park, 3211 Hickory Tree Rd, Balch Springs, TX",
                    contract: "Enhancement Agreement 9146",
                    start: "2025-07-31T07:30:00+05:00",
                    end: "2025-07-31T08:26:00+05:00",
                    origin: {
                      lat: 32.72490505441594,
                      lng: -96.62671927834478,
                    },
                    drive_time: "56",
                    durationMinutes: 56,
                  },
                  {
                    id: "landscape_maintenance-visit-099",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "8:32 AM",
                    endTime: "11:14 AM",
                    address: "142766-2706 Peachtree Rd, Balch Springs, TX",
                    contract: "Enhancement Agreement 1431",
                    start: "2025-07-31T08:32:00+05:00",
                    end: "2025-07-31T11:14:00+05:00",
                    origin: {
                      lat: 32.732227927637275,
                      lng: -96.6313313061763,
                    },
                    drive_time: "162",
                    durationMinutes: 162,
                  },
                  {
                    id: "landscape_maintenance-visit-100",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "11:28 AM",
                    endTime: "1:20 PM",
                    address: "20 Edgemont Park, Mesquite, TX",
                    contract: "Enhancement Agreement 6386",
                    start: "2025-07-31T11:28:00+05:00",
                    end: "2025-07-31T13:20:00+05:00",
                    origin: {
                      lat: 32.745780688186954,
                      lng: -96.61801442761346,
                    },
                    drive_time: "112",
                    durationMinutes: 112,
                  },
                  {
                    id: "landscape_maintenance-visit-101",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "3:17 PM",
                    address: "1912722 Lake June Rd, Mesquite, TX",
                    contract: "Enhancement Agreement 9875",
                    start: "2025-07-31T13:40:00+05:00",
                    end: "2025-07-31T15:17:00+05:00",
                    origin: {
                      lat: 32.73700577891816,
                      lng: -96.60896302046001,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                  },
                  {
                    id: "landscape_maintenance-visit-102",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:36 PM",
                    endTime: "4:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T15:36:00+05:00",
                    end: "2025-07-31T16:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-803",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "88636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T07:00:00+05:00",
                    end: "2025-07-24T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-804",
                    title: "Oakdale Senior Center",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "8:15 AM",
                    address: "35105637 Hunters Bend Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20584",
                    start: "2025-07-24T07:40:00+05:00",
                    end: "2025-07-24T08:15:00+05:00",
                    origin: {
                      lat: 32.65537421687229,
                      lng: -96.97332544996381,
                    },
                    drive_time: "35",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-805",
                    title: "Brookstone Plaza",
                    status: "scheduled",
                    startTime: "8:26 AM",
                    endTime: "8:51 AM",
                    address: "25115621 Bandit Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20585",
                    start: "2025-07-24T08:26:00+05:00",
                    end: "2025-07-24T08:51:00+05:00",
                    origin: {
                      lat: 32.65793132845956,
                      lng: -96.96997676403906,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-806",
                    title: "Elm Creek HOA",
                    status: "scheduled",
                    startTime: "8:57 AM",
                    endTime: "9:30 AM",
                    address: "3365666 Mountain Hollow Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20586",
                    start: "2025-07-24T08:57:00+05:00",
                    end: "2025-07-24T09:30:00+05:00",
                    origin: {
                      lat: 32.65727746412962,
                      lng: -96.96548980363775,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-807",
                    title: "Highland Commons",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:05 AM",
                    address: "2875680 Centeridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20587",
                    start: "2025-07-24T09:37:00+05:00",
                    end: "2025-07-24T10:05:00+05:00",
                    origin: {
                      lat: 32.65848800584531,
                      lng: -96.96247565034557,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-808",
                    title: "Briarwood Medical",
                    status: "scheduled",
                    startTime: "10:18 AM",
                    endTime: "10:43 AM",
                    address: "25137917 Vista Hill Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20588",
                    start: "2025-07-24T10:18:00+05:00",
                    end: "2025-07-24T10:43:00+05:00",
                    origin: {
                      lat: 32.65588730116591,
                      lng: -96.96155785883717,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-809",
                    title: "Lakeview Apartments",
                    status: "scheduled",
                    startTime: "10:52 AM",
                    endTime: "11:23 AM",
                    address: "3198635-8799 Granville Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20589",
                    start: "2025-07-24T10:52:00+05:00",
                    end: "2025-07-24T11:23:00+05:00",
                    origin: {
                      lat: 32.657329702530106,
                      lng: -96.95182588465576,
                    },
                    drive_time: "31",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-810",
                    title: "Whispering Pines Park",
                    status: "scheduled",
                    startTime: "11:33 AM",
                    endTime: "11:58 AM",
                    address: "25108441 Clark Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20590",
                    start: "2025-07-24T11:33:00+05:00",
                    end: "2025-07-24T11:58:00+05:00",
                    origin: {
                      lat: 32.66098299324898,
                      lng: -96.94440557908295,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-811",
                    title: "Sunset Commercial Lot",
                    status: "scheduled",
                    startTime: "12:04 PM",
                    endTime: "12:29 PM",
                    address: "2561407 W Ridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20591",
                    start: "2025-07-24T12:04:00+05:00",
                    end: "2025-07-24T12:29:00+05:00",
                    origin: {
                      lat: 32.656571503312556,
                      lng: -96.94134323823776,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-812",
                    title: "Orchard Villas",
                    status: "scheduled",
                    startTime: "12:41 PM",
                    endTime: "1:06 PM",
                    address: "25126823 Cedar Forest Trail, Dallas, TX",
                    contract: "Maintenance Agreement 20592",
                    start: "2025-07-24T12:41:00+05:00",
                    end: "2025-07-24T13:06:00+05:00",
                    origin: {
                      lat: 32.664738578647075,
                      lng: -96.93503995031634,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-813",
                    title: "Linden Estates",
                    status: "scheduled",
                    startTime: "1:19 PM",
                    endTime: "1:49 PM",
                    address: "30136927 Clarkridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20593",
                    start: "2025-07-24T13:19:00+05:00",
                    end: "2025-07-24T13:49:00+05:00",
                    origin: {
                      lat: 32.66781678212907,
                      lng: -96.9434105721135,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-814",
                    title: "Redbud Office Center",
                    status: "scheduled",
                    startTime: "2:03 PM",
                    endTime: "2:35 PM",
                    address: "32148303 Timberbrook Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20594",
                    start: "2025-07-24T14:03:00+05:00",
                    end: "2025-07-24T14:35:00+05:00",
                    origin: {
                      lat: 32.66542401234956,
                      lng: -96.95120340724914,
                    },
                    drive_time: "32",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-815",
                    title: "Windsor Hill Retail",
                    status: "scheduled",
                    startTime: "2:48 PM",
                    endTime: "3:13 PM",
                    address: "25136640 Legters Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20595",
                    start: "2025-07-24T14:48:00+05:00",
                    end: "2025-07-24T15:13:00+05:00",
                    origin: {
                      lat: 32.667104262352105,
                      lng: -96.95313191395635,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-816",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "3:13 PM",
                    endTime: "3:43 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T15:13:00+05:00",
                    end: "2025-07-24T15:43:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "CN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-644",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "188636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-645",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:48 AM",
                    endTime: "3:28 PM",
                    address: "460121500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 4456",
                    start: "2025-07-31T07:48:00+05:00",
                    end: "2025-07-31T15:28:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "460",
                    durationMinutes: 460,
                  },
                  {
                    id: "landscape_maintenance-visit-646",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:40:00+05:00",
                    end: "2025-07-31T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },

              {
                id: "crew-d-003",
                name: "CN 2",
                crew_leader: "John Ferris",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-824",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "348636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T07:00:00+05:00",
                    end: "2025-07-24T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-825",
                    title: "Silverbrook Heights",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "3:21 PM",
                    address: "461191225 Canton St, Dallas, TX",
                    contract: "Construction Project 6340",
                    start: "2025-07-24T07:40:00+05:00",
                    end: "2025-07-24T15:21:00+05:00",
                    origin: {
                      lat: 32.77363407835754,
                      lng: -96.79852861103222,
                    },
                    drive_time: "461",
                    durationMinutes: 461,
                  },
                  {
                    id: "landscape_maintenance-visit-826",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-24T15:40:00+05:00",
                    end: "2025-07-24T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    date: "2026-05-22",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-270",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-271",
                    title: "Laurel Park Commons",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:06 AM",
                    address: "72200 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20628",
                    start: "2025-08-01T07:37:00+05:00",
                    end: "2025-08-01T08:06:00+05:00",
                    origin: {
                      lat: 32.82700062143119,
                      lng: -96.97545355404942,
                    },
                    drive_time: "29",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-272",
                    title: "Willowview HOA",
                    status: "scheduled",
                    startTime: "8:18 AM",
                    endTime: "8:44 AM",
                    address: "121603 Priscilla Ln, Irving, TX",
                    contract: "Maintenance Agreement 20629",
                    start: "2025-08-01T08:18:00+05:00",
                    end: "2025-08-01T08:44:00+05:00",
                    origin: {
                      lat: 32.83158778723434,
                      lng: -96.97103910479787,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-273",
                    title: "The Branch Offices",
                    status: "scheduled",
                    startTime: "8:52 AM",
                    endTime: "9:20 AM",
                    address: "81709 Green Oaks Dr, Irving, TX",
                    contract: "Maintenance Agreement 20630",
                    start: "2025-08-01T08:52:00+05:00",
                    end: "2025-08-01T09:20:00+05:00",
                    origin: {
                      lat: 32.832432887464925,
                      lng: -96.96678781110751,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-274",
                    title: "Fox Hill Plaza",
                    status: "scheduled",
                    startTime: "9:33 AM",
                    endTime: "10:06 AM",
                    address: "13267 W St Clair Dr, Irving, TX",
                    contract: "Maintenance Agreement 20631",
                    start: "2025-08-01T09:33:00+05:00",
                    end: "2025-08-01T10:06:00+05:00",
                    origin: {
                      lat: 32.82459779966745,
                      lng: -96.96212813072863,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-275",
                    title: "Northaven Suites",
                    status: "scheduled",
                    startTime: "10:13 AM",
                    endTime: "10:38 AM",
                    address: "71311 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20632",
                    start: "2025-08-01T10:13:00+05:00",
                    end: "2025-08-01T10:38:00+05:00",
                    origin: {
                      lat: 32.81738323907385,
                      lng: -96.96163571966576,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-276",
                    title: "Springridge Center",
                    status: "scheduled",
                    startTime: "10:48 AM",
                    endTime: "11:15 AM",
                    address: "101309 Limetree Ln, Irving, TX",
                    contract: "Maintenance Agreement 20633",
                    start: "2025-08-01T10:48:00+05:00",
                    end: "2025-08-01T11:15:00+05:00",
                    origin: {
                      lat: 32.82658243688681,
                      lng: -96.95362221982374,
                    },
                    drive_time: "10",
                    durationMinutes: 27,
                  },
                  {
                    id: "landscape_maintenance-visit-277",
                    title: "Midpark Towers",
                    status: "scheduled",
                    startTime: "11:20 AM",
                    endTime: "12:05 PM",
                    address: "51118 Brady Dr, Irving, TX",
                    contract: "Maintenance Agreement 20634",
                    start: "2025-08-01T11:20:00+05:00",
                    end: "2025-08-01T12:05:00+05:00",
                    origin: {
                      lat: 32.82671809190914,
                      lng: -96.94998831806257,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-278",
                    title: "Cottonwood Villas",
                    status: "scheduled",
                    startTime: "12:13 PM",
                    endTime: "12:39 PM",
                    address: "81946 Shoaf Dr, Irving, TX",
                    contract: "Maintenance Agreement 20635",
                    start: "2025-08-01T12:13:00+05:00",
                    end: "2025-08-01T12:39:00+05:00",
                    origin: {
                      lat: 32.83422926324008,
                      lng: -96.94588238382623,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-279",
                    title: "Valley Glen Retail",
                    status: "scheduled",
                    startTime: "12:45 PM",
                    endTime: "1:10 PM",
                    address: "62021 Shoaf Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20636",
                    start: "2025-08-01T12:45:00+05:00",
                    end: "2025-08-01T13:10:00+05:00",
                    origin: {
                      lat: 32.83518441521939,
                      lng: -96.94790165829477,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-280",
                    title: "Hidden Creek Plaza",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "13122 W Holland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20637",
                    start: "2025-08-01T13:23:00+05:00",
                    end: "2025-08-01T13:48:00+05:00",
                    origin: {
                      lat: 32.83841754739589,
                      lng: -96.94561778664372,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-281",
                    title: "Ridgewood Shops",
                    status: "scheduled",
                    startTime: "1:55 PM",
                    endTime: "2:26 PM",
                    address: "72326 W Newton Cir, Dallas, TX",
                    contract: "Maintenance Agreement 20638",
                    start: "2025-08-01T13:55:00+05:00",
                    end: "2025-08-01T14:26:00+05:00",
                    origin: {
                      lat: 32.83931617496474,
                      lng: -96.94817451366447,
                    },
                    drive_time: "7",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-282",
                    title: "Southside Gardens",
                    status: "scheduled",
                    startTime: "2:37 PM",
                    endTime: "3:02 PM",
                    address: "112328 Brockbank Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20639",
                    start: "2025-08-01T14:37:00+05:00",
                    end: "2025-08-01T15:02:00+05:00",
                    origin: {
                      lat: 32.83917228935476,
                      lng: -96.94994426998946,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-283",
                    title: "The Gables at Oak",
                    status: "scheduled",
                    startTime: "3:16 PM",
                    endTime: "3:41 PM",
                    address: "14120 E Scotland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20640",
                    start: "2025-08-01T15:16:00+05:00",
                    end: "2025-08-01T15:41:00+05:00",
                    origin: {
                      lat: 32.840372057900865,
                      lng: -96.94357860432224,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-284",
                    title: "North Cliff Commons",
                    status: "scheduled",
                    startTime: "3:49 PM",
                    endTime: "4:36 PM",
                    address: "81403 English St, Dallas, TX",
                    contract: "Maintenance Agreement 20641",
                    start: "2025-08-01T15:49:00+05:00",
                    end: "2025-08-01T16:36:00+05:00",
                    origin: {
                      lat: 32.828681781644484,
                      lng: -96.93769216199404,
                    },
                    drive_time: "47",
                    durationMinutes: 47,
                  },
                  {
                    id: "landscape_maintenance-visit-285",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "4:36 PM",
                    endTime: "5:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T16:36:00+05:00",
                    end: "2025-08-01T17:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-068",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-27T07:00:00+05:00",
                    end: "2025-07-27T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-069",
                    title: "Willow Creek HOA",
                    status: "scheduled",
                    startTime: "7:43 AM",
                    endTime: "8:20 AM",
                    address: "13100 Pandora Dr, Dallas, TX",
                    contract: "Irrigation Service 7216",
                    start: "2025-07-27T07:43:00+05:00",
                    end: "2025-07-27T08:20:00+05:00",
                    origin: {
                      lat: 32.8740736707406,
                      lng: -96.6868538441954,
                    },
                    drive_time: "13",
                    durationMinutes: 37,
                  },
                  {
                    id: "landscape_maintenance-visit-070",
                    title: "Preston Oaks Apartments",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "11:10 AM",
                    address: "11333 Amanda Ln, Dallas, TX",
                    contract: "Irrigation Service 5422",
                    start: "2025-07-27T08:40:00+05:00",
                    end: "2025-07-27T11:10:00+05:00",
                    origin: {
                      lat: 32.87481638479381,
                      lng: -96.69074024259228,
                    },
                    drive_time: "20",
                    durationMinutes: 150,
                  },
                  {
                    id: "landscape_maintenance-visit-071",
                    title: "Maplewood Residence",
                    status: "scheduled",
                    startTime: "11:26 AM",
                    endTime: "11:51 AM",
                    address: "16 Wickersham Rd, Dallas, TX",
                    contract: "Irrigation Service 4598",
                    start: "2025-07-27T11:26:00+05:00",
                    end: "2025-07-27T11:51:00+05:00",
                    origin: {
                      lat: 32.877869419462634,
                      lng: -96.69105815935272,
                    },
                    drive_time: "16",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-072",
                    title: "Royal Lane Retail",
                    status: "scheduled",
                    startTime: "12:11 PM",
                    endTime: "12:58 PM",
                    address: "11140 Petal St, Dallas, TX",
                    contract: "Irrigation Service 6313",
                    start: "2025-07-27T12:11:00+05:00",
                    end: "2025-07-27T12:58:00+05:00",
                    origin: {
                      lat: 32.88215743426728,
                      lng: -96.68897171292429,
                    },
                    drive_time: "20",
                    durationMinutes: 47,
                  },
                  {
                    id: "landscape_maintenance-visit-073",
                    title: "Lake Highlands Estate",
                    status: "scheduled",
                    startTime: "1:18 PM",
                    endTime: "2:50 PM",
                    address: "10922 Listi Dr, Dallas, TX",
                    contract: "Irrigation Service 1916",
                    start: "2025-07-27T13:18:00+05:00",
                    end: "2025-07-27T14:50:00+05:00",
                    origin: {
                      lat: 32.87197789385975,
                      lng: -96.69547294391265,
                    },
                    drive_time: "20",
                    durationMinutes: 92,
                  },
                  {
                    id: "landscape_maintenance-visit-074",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "2:50 PM",
                    endTime: "3:20 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-27T14:50:00+05:00",
                    end: "2025-07-27T15:20:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-115",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-116",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-08-01T07:40:00+05:00",
                    end: "2025-08-01T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-117",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-08-01T09:08:00+05:00",
                    end: "2025-08-01T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-118",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-08-01T10:08:00+05:00",
                    end: "2025-08-01T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-119",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-08-01T11:01:00+05:00",
                    end: "2025-08-01T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-120",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-08-01T12:30:00+05:00",
                    end: "2025-08-01T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-121",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-08-01T13:58:00+05:00",
                    end: "2025-08-01T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-122",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-08-01T14:46:00+05:00",
                    end: "2025-08-01T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-123",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-08-01T15:35:00+05:00",
                    end: "2025-08-01T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-124",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-08-01T16:23:00+05:00",
                    end: "2025-08-01T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-125",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-08-01T17:15:00+05:00",
                    end: "2025-08-01T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-126",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T17:58:00+05:00",
                    end: "2025-08-01T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-647",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "148636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-648",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:44 AM",
                    endTime: "1:24 PM",
                    address: "340181500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 5040",
                    start: "2025-08-01T07:44:00+05:00",
                    end: "2025-08-01T13:24:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "340",
                    durationMinutes: 340,
                  },
                  {
                    id: "landscape_maintenance-visit-649",
                    title: "Oak Cliff Market Center",
                    status: "scheduled",
                    startTime: "1:42 PM",
                    endTime: "3:25 PM",
                    address: "103141606 Westwood Dr, Dallas, TX",
                    contract: "Construction Project 9830",
                    start: "2025-08-01T13:42:00+05:00",
                    end: "2025-08-01T15:25:00+05:00",
                    origin: {
                      lat: 32.798254354938415,
                      lng: -96.96063291232817,
                    },
                    drive_time: "103",
                    durationMinutes: 103,
                  },
                  {
                    id: "landscape_maintenance-visit-650",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:39 PM",
                    endTime: "4:09 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T15:39:00+05:00",
                    end: "2025-08-01T16:09:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  // future week
  {
    date: "2026-05-25",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-351",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-352",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-28T07:40:00+05:00",
                    end: "2025-07-28T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-353",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-28T09:08:00+05:00",
                    end: "2025-07-28T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-354",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-28T10:08:00+05:00",
                    end: "2025-07-28T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-355",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-28T11:01:00+05:00",
                    end: "2025-07-28T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-356",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-28T12:30:00+05:00",
                    end: "2025-07-28T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-357",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-28T13:58:00+05:00",
                    end: "2025-07-28T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-358",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-28T14:46:00+05:00",
                    end: "2025-07-28T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-359",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-28T15:35:00+05:00",
                    end: "2025-07-28T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-360",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-28T16:23:00+05:00",
                    end: "2025-07-28T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-361",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-28T17:15:00+05:00",
                    end: "2025-07-28T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-362",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T17:58:00+05:00",
                    end: "2025-07-28T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-469",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-470",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-28T07:40:00+05:00",
                    end: "2025-07-28T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-471",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-28T09:08:00+05:00",
                    end: "2025-07-28T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-472",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-28T10:08:00+05:00",
                    end: "2025-07-28T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-473",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-28T11:01:00+05:00",
                    end: "2025-07-28T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-474",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-28T12:30:00+05:00",
                    end: "2025-07-28T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-475",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-28T13:58:00+05:00",
                    end: "2025-07-28T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-476",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-28T14:46:00+05:00",
                    end: "2025-07-28T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-477",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-28T15:35:00+05:00",
                    end: "2025-07-28T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-478",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-28T16:23:00+05:00",
                    end: "2025-07-28T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-479",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T17:58:00+05:00",
                    end: "2025-07-28T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-572",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "68636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-573",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "7:30 AM",
                    endTime: "8:26 AM",
                    address:
                      "566 Luedeke Park, 3211 Hickory Tree Rd, Balch Springs, TX",
                    contract: "Enhancement Agreement 9146",
                    start: "2025-07-28T07:30:00+05:00",
                    end: "2025-07-28T08:26:00+05:00",
                    origin: {
                      lat: 32.72490505441594,
                      lng: -96.62671927834478,
                    },
                    drive_time: "56",
                    durationMinutes: 56,
                  },
                  {
                    id: "landscape_maintenance-visit-574",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "8:32 AM",
                    endTime: "11:14 AM",
                    address: "162142766-2706 Peachtree Rd, Balch Springs, TX",
                    contract: "Enhancement Agreement 1431",
                    start: "2025-07-28T08:32:00+05:00",
                    end: "2025-07-28T11:14:00+05:00",
                    origin: {
                      lat: 32.732227927637275,
                      lng: -96.6313313061763,
                    },
                    drive_time: "162",
                    durationMinutes: 162,
                  },
                  {
                    id: "landscape_maintenance-visit-575",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "11:28 AM",
                    endTime: "1:20 PM",
                    address: "11220 Edgemont Park, Mesquite, TX",
                    contract: "Enhancement Agreement 6386",
                    start: "2025-07-28T11:28:00+05:00",
                    end: "2025-07-28T13:20:00+05:00",
                    origin: {
                      lat: 32.745780688186954,
                      lng: -96.61801442761346,
                    },
                    drive_time: "112",
                    durationMinutes: 112,
                  },
                  {
                    id: "landscape_maintenance-visit-576",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "3:17 PM",
                    address: "971912722 Lake June Rd, Mesquite, TX",
                    contract: "Enhancement Agreement 9875",
                    start: "2025-07-28T13:40:00+05:00",
                    end: "2025-07-28T15:17:00+05:00",
                    origin: {
                      lat: 32.73700577891816,
                      lng: -96.60896302046001,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                  },
                  {
                    id: "landscape_maintenance-visit-577",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:36 PM",
                    endTime: "4:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T15:36:00+05:00",
                    end: "2025-07-28T16:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-651",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "188636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-652",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:48 AM",
                    endTime: "3:28 PM",
                    address: "460121500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 4456",
                    start: "2025-07-28T07:48:00+05:00",
                    end: "2025-07-28T15:28:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "460",
                    durationMinutes: 460,
                  },
                  {
                    id: "landscape_maintenance-visit-653",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-28T15:40:00+05:00",
                    end: "2025-07-28T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-26",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-363",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-364",
                    title: "Elm Grove Condos",
                    status: "scheduled",
                    startTime: "7:42 AM",
                    endTime: "8:10 AM",
                    address: "121234 Templecliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20613",
                    start: "2025-07-29T07:42:00+05:00",
                    end: "2025-07-29T08:10:00+05:00",
                    origin: {
                      lat: 32.73382673768448,
                      lng: -96.7039446,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-365",
                    title: "Lakewood Plaza",
                    status: "scheduled",
                    startTime: "8:20 AM",
                    endTime: "8:45 AM",
                    address: "101515 N Jim Miller Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20614",
                    start: "2025-07-29T08:20:00+05:00",
                    end: "2025-07-29T08:45:00+05:00",
                    origin: {
                      lat: 32.73939495440909,
                      lng: -96.70192221780633,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-366",
                    title: "Fair Oaks Retail",
                    status: "scheduled",
                    startTime: "8:54 AM",
                    endTime: "9:24 AM",
                    address: "96937 Umphress Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20615",
                    start: "2025-07-29T08:54:00+05:00",
                    end: "2025-07-29T09:24:00+05:00",
                    origin: {
                      lat: 32.74174537738961,
                      lng: -96.70189263337386,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-367",
                    title: "The Overlook HOA",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:02 AM",
                    address: "131703 Rocky Pl Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20616",
                    start: "2025-07-29T09:37:00+05:00",
                    end: "2025-07-29T10:02:00+05:00",
                    origin: {
                      lat: 32.74175237157451,
                      lng: -96.70101130412979,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-368",
                    title: "Brookstone Suites",
                    status: "scheduled",
                    startTime: "10:09 AM",
                    endTime: "10:34 AM",
                    address: "76902 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20617",
                    start: "2025-07-29T10:09:00+05:00",
                    end: "2025-07-29T10:34:00+05:00",
                    origin: {
                      lat: 32.742739134759965,
                      lng: -96.70301784305627,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-369",
                    title: "Hilltop Center",
                    status: "scheduled",
                    startTime: "10:42 AM",
                    endTime: "11:13 AM",
                    address: "86803 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20618",
                    start: "2025-07-29T10:42:00+05:00",
                    end: "2025-07-29T11:13:00+05:00",
                    origin: {
                      lat: 32.74326442753792,
                      lng: -96.70409202785368,
                    },
                    drive_time: "8",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-370",
                    title: "Westridge Medical",
                    status: "scheduled",
                    startTime: "11:22 AM",
                    endTime: "11:58 AM",
                    address: "91734 Eastcliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20619",
                    start: "2025-07-29T11:22:00+05:00",
                    end: "2025-07-29T11:58:00+05:00",
                    origin: {
                      lat: 32.74270897105405,
                      lng: -96.70594163276925,
                    },
                    drive_time: "9",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-371",
                    title: "Park Haven Offices",
                    status: "scheduled",
                    startTime: "12:10 PM",
                    endTime: "12:35 PM",
                    address: "6712-6798 Overpark Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20620",
                    start: "2025-07-29T12:10:00+05:00",
                    end: "2025-07-29T12:35:00+05:00",
                    origin: {
                      lat: 32.74158373926312,
                      lng: -96.70466253702625,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-372",
                    title: "Villas at Preston",
                    status: "scheduled",
                    startTime: "12:46 PM",
                    endTime: "1:16 PM",
                    address: "7015 Petty Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20621",
                    start: "2025-07-29T12:46:00+05:00",
                    end: "2025-07-29T13:16:00+05:00",
                    origin: {
                      lat: 32.744066518149474,
                      lng: -96.70195797501958,
                    },
                    drive_time: "11",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-373",
                    title: "Creekside Townhomes",
                    status: "scheduled",
                    startTime: "1:29 PM",
                    endTime: "1:54 PM",
                    address: "7034 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20622",
                    start: "2025-07-29T13:29:00+05:00",
                    end: "2025-07-29T13:54:00+05:00",
                    origin: {
                      lat: 32.744552905644404,
                      lng: -96.7009760120773,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-374",
                    title: "Midway Business Hub",
                    status: "scheduled",
                    startTime: "2:01 PM",
                    endTime: "2:27 PM",
                    address: "76925 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20623",
                    start: "2025-07-29T14:01:00+05:00",
                    end: "2025-07-29T14:27:00+05:00",
                    origin: {
                      lat: 32.744964457415065,
                      lng: -96.7031389159949,
                    },
                    drive_time: "7",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-375",
                    title: "Sunset Terrace",
                    status: "scheduled",
                    startTime: "2:33 PM",
                    endTime: "2:58 PM",
                    address: "62036 Earnhardt Way, Dallas, TX",
                    contract: "Maintenance Agreement 20624",
                    start: "2025-07-29T14:33:00+05:00",
                    end: "2025-07-29T14:58:00+05:00",
                    origin: {
                      lat: 32.74774466169055,
                      lng: -96.70055250157739,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-376",
                    title: "The Oaks HOA",
                    status: "scheduled",
                    startTime: "3:05 PM",
                    endTime: "3:38 PM",
                    address: "77120 Clearpoint Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20625",
                    start: "2025-07-29T15:05:00+05:00",
                    end: "2025-07-29T15:38:00+05:00",
                    origin: {
                      lat: 32.746171539123075,
                      lng: -96.69917866641367,
                    },
                    drive_time: "7",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-377",
                    title: "Commerce Crossing",
                    status: "scheduled",
                    startTime: "3:48 PM",
                    endTime: "4:33 PM",
                    address: "101830 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20626",
                    start: "2025-07-29T15:48:00+05:00",
                    end: "2025-07-29T16:33:00+05:00",
                    origin: {
                      lat: 32.74388337540704,
                      lng: -96.69849674556865,
                    },
                    drive_time: "10",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-378",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "5:07 PM",
                    endTime: "5:37 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T17:07:00+05:00",
                    end: "2025-07-29T17:37:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-480",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-481",
                    title: "Willow Creek HOA",
                    status: "scheduled",
                    startTime: "7:43 AM",
                    endTime: "8:20 AM",
                    address: "1313100 Pandora Dr, Dallas, TX",
                    contract: "Irrigation Service 7216",
                    start: "2025-07-29T07:43:00+05:00",
                    end: "2025-07-29T08:20:00+05:00",
                    origin: {
                      lat: 32.8740736707406,
                      lng: -96.6868538441954,
                    },
                    drive_time: "37",
                    durationMinutes: 37,
                  },
                  {
                    id: "landscape_maintenance-visit-482",
                    title: "Preston Oaks Apartments",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "11:10 AM",
                    address: "2011333 Amanda Ln, Dallas, TX",
                    contract: "Irrigation Service 5422",
                    start: "2025-07-29T08:40:00+05:00",
                    end: "2025-07-29T11:10:00+05:00",
                    origin: {
                      lat: 32.87481638479381,
                      lng: -96.69074024259228,
                    },
                    drive_time: "150",
                    durationMinutes: 150,
                  },
                  {
                    id: "landscape_maintenance-visit-483",
                    title: "Maplewood Residence",
                    status: "scheduled",
                    startTime: "11:26 AM",
                    endTime: "11:51 AM",
                    address: "16 Wickersham Rd, Dallas, TX",
                    contract: "Irrigation Service 4598",
                    start: "2025-07-29T11:26:00+05:00",
                    end: "2025-07-29T11:51:00+05:00",
                    origin: {
                      lat: 32.877869419462634,
                      lng: -96.69105815935272,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-484",
                    title: "Royal Lane Retail",
                    status: "scheduled",
                    startTime: "12:11 PM",
                    endTime: "12:58 PM",
                    address: "2011140 Petal St, Dallas, TX",
                    contract: "Irrigation Service 6313",
                    start: "2025-07-29T12:11:00+05:00",
                    end: "2025-07-29T12:58:00+05:00",
                    origin: {
                      lat: 32.88215743426728,
                      lng: -96.68897171292429,
                    },
                    drive_time: "47",
                    durationMinutes: 47,
                  },
                  {
                    id: "landscape_maintenance-visit-485",
                    title: "Lake Highlands Estate",
                    status: "scheduled",
                    startTime: "1:18 PM",
                    endTime: "2:50 PM",
                    address: "2010922 Listi Dr, Dallas, TX",
                    contract: "Irrigation Service 1916",
                    start: "2025-07-29T13:18:00+05:00",
                    end: "2025-07-29T14:50:00+05:00",
                    origin: {
                      lat: 32.87197789385975,
                      lng: -96.69547294391265,
                    },
                    drive_time: "92",
                    durationMinutes: 92,
                  },
                  {
                    id: "landscape_maintenance-visit-486",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "2:50 PM",
                    endTime: "3:20 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T14:50:00+05:00",
                    end: "2025-07-29T15:20:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-578",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-579",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-29T07:40:00+05:00",
                    end: "2025-07-29T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-580",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-29T09:08:00+05:00",
                    end: "2025-07-29T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-581",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-29T10:08:00+05:00",
                    end: "2025-07-29T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-582",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-29T11:01:00+05:00",
                    end: "2025-07-29T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-583",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-29T12:30:00+05:00",
                    end: "2025-07-29T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-584",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-29T13:58:00+05:00",
                    end: "2025-07-29T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-585",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-29T14:46:00+05:00",
                    end: "2025-07-29T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-586",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-29T15:35:00+05:00",
                    end: "2025-07-29T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-587",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-29T16:23:00+05:00",
                    end: "2025-07-29T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-588",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T17:58:00+05:00",
                    end: "2025-07-29T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-654",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "188636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-655",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:48 AM",
                    endTime: "3:28 PM",
                    address: "460121500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 4456",
                    start: "2025-07-29T07:48:00+05:00",
                    end: "2025-07-29T15:28:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "460",
                    durationMinutes: 460,
                  },
                  {
                    id: "landscape_maintenance-visit-656",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-29T15:40:00+05:00",
                    end: "2025-07-29T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-27",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-379",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-380",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-30T07:40:00+05:00",
                    end: "2025-07-30T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-381",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-30T09:08:00+05:00",
                    end: "2025-07-30T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-382",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-30T10:08:00+05:00",
                    end: "2025-07-30T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-383",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-30T11:01:00+05:00",
                    end: "2025-07-30T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-384",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-30T12:30:00+05:00",
                    end: "2025-07-30T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-385",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-30T13:58:00+05:00",
                    end: "2025-07-30T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-386",
                    title: "Briarwood Villas",
                    status: "scheduled",
                    startTime: "2:46 PM",
                    endTime: "3:28 PM",
                    address: "8501 Larry Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3166",
                    start: "2025-07-30T14:46:00+05:00",
                    end: "2025-07-30T15:28:00+05:00",
                    origin: {
                      lat: 32.64764904833626,
                      lng: -96.52392454384498,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-387",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-30T15:35:00+05:00",
                    end: "2025-07-30T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-388",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-30T16:23:00+05:00",
                    end: "2025-07-30T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-389",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-30T17:15:00+05:00",
                    end: "2025-07-30T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-390",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T17:58:00+05:00",
                    end: "2025-07-30T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-487",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-488",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-30T07:40:00+05:00",
                    end: "2025-07-30T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-489",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-30T09:08:00+05:00",
                    end: "2025-07-30T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-490",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-30T10:08:00+05:00",
                    end: "2025-07-30T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-491",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-30T11:01:00+05:00",
                    end: "2025-07-30T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-492",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-30T12:30:00+05:00",
                    end: "2025-07-30T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-493",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-30T13:58:00+05:00",
                    end: "2025-07-30T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-494",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-30T15:35:00+05:00",
                    end: "2025-07-30T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-495",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-30T16:23:00+05:00",
                    end: "2025-07-30T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-496",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-30T17:15:00+05:00",
                    end: "2025-07-30T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-497",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T17:58:00+05:00",
                    end: "2025-07-30T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-589",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-590",
                    title: "Preston Hollow Estates",
                    status: "scheduled",
                    startTime: "7:40 AM",
                    endTime: "9:00 AM",
                    address: "10401 Combine Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 7659",
                    start: "2025-07-30T07:40:00+05:00",
                    end: "2025-07-30T09:00:00+05:00",
                    origin: {
                      lat: 32.63397565772838,
                      lng: -96.53010159312184,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-591",
                    title: "Park Lane Terraces",
                    status: "scheduled",
                    startTime: "9:08 AM",
                    endTime: "10:00 AM",
                    address: "8412 N Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 7557",
                    start: "2025-07-30T09:08:00+05:00",
                    end: "2025-07-30T10:00:00+05:00",
                    origin: {
                      lat: 32.63728896568596,
                      lng: -96.53394734691632,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                  },
                  {
                    id: "landscape_maintenance-visit-592",
                    title: "Maple District Commons",
                    status: "scheduled",
                    startTime: "10:08 AM",
                    endTime: "10:52 AM",
                    address: "8407 Flowers St, Seagoville, TX",
                    contract: "Enhancement Agreement 2054",
                    start: "2025-07-30T10:08:00+05:00",
                    end: "2025-07-30T10:52:00+05:00",
                    origin: {
                      lat: 32.6386662789194,
                      lng: -96.53323620157416,
                    },
                    drive_time: "44",
                    durationMinutes: 44,
                  },
                  {
                    id: "landscape_maintenance-visit-593",
                    title: "Highland Greens",
                    status: "scheduled",
                    startTime: "11:01 AM",
                    endTime: "12:21 PM",
                    address: "9218 E Bluff Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 6717",
                    start: "2025-07-30T11:01:00+05:00",
                    end: "2025-07-30T12:21:00+05:00",
                    origin: {
                      lat: 32.638821239485104,
                      lng: -96.53003255536575,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-594",
                    title: "Casa Linda Enclave",
                    status: "scheduled",
                    startTime: "12:30 PM",
                    endTime: "1:50 PM",
                    address: "9521 Water St, Seagoville, TX",
                    contract: "Enhancement Agreement 4673",
                    start: "2025-07-30T12:30:00+05:00",
                    end: "2025-07-30T13:50:00+05:00",
                    origin: {
                      lat: 32.64367847714571,
                      lng: -96.53094536943287,
                    },
                    drive_time: "80",
                    durationMinutes: 80,
                  },
                  {
                    id: "landscape_maintenance-visit-595",
                    title: "Lakewood Gardens",
                    status: "scheduled",
                    startTime: "1:58 PM",
                    endTime: "2:38 PM",
                    address: "81000 E Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 2784",
                    start: "2025-07-30T13:58:00+05:00",
                    end: "2025-07-30T14:38:00+05:00",
                    origin: {
                      lat: 32.6501419002588,
                      lng: -96.5290516739278,
                    },
                    drive_time: "40",
                    durationMinutes: 40,
                  },
                  {
                    id: "landscape_maintenance-visit-596",
                    title: "Oak Cliff Residences",
                    status: "scheduled",
                    startTime: "3:35 PM",
                    endTime: "4:17 PM",
                    address: "7205 S Kaufman St, Seagoville, TX",
                    contract: "Enhancement Agreement 5331",
                    start: "2025-07-30T15:35:00+05:00",
                    end: "2025-07-30T16:17:00+05:00",
                    origin: {
                      lat: 32.63926975596064,
                      lng: -96.53700496620446,
                    },
                    drive_time: "42",
                    durationMinutes: 42,
                  },
                  {
                    id: "landscape_maintenance-visit-597",
                    title: "Northwood Hills",
                    status: "scheduled",
                    startTime: "4:23 PM",
                    endTime: "5:06 PM",
                    address: "6 W Malloy Bridge Rd, Seagoville, TX",
                    contract: "Enhancement Agreement 8849",
                    start: "2025-07-30T16:23:00+05:00",
                    end: "2025-07-30T17:06:00+05:00",
                    origin: {
                      lat: 32.63788220873143,
                      lng: -96.53948474016666,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-598",
                    title: "Uptown Grove",
                    status: "scheduled",
                    startTime: "5:15 PM",
                    endTime: "5:58 PM",
                    address: "9324-384 Riley Dr, Seagoville, TX",
                    contract: "Enhancement Agreement 3581",
                    start: "2025-07-30T17:15:00+05:00",
                    end: "2025-07-30T17:58:00+05:00",
                    origin: {
                      lat: 32.63621414632312,
                      lng: -96.5373929499692,
                    },
                    drive_time: "43",
                    durationMinutes: 43,
                  },
                  {
                    id: "landscape_maintenance-visit-599",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "5:58 PM",
                    endTime: "6:28 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T17:58:00+05:00",
                    end: "2025-07-30T18:28:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-657",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "188636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-658",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:48 AM",
                    endTime: "3:28 PM",
                    address: "460121500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 4456",
                    start: "2025-07-30T07:48:00+05:00",
                    end: "2025-07-30T15:28:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "460",
                    durationMinutes: 460,
                  },
                  {
                    id: "landscape_maintenance-visit-659",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-30T15:40:00+05:00",
                    end: "2025-07-30T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-28",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-391",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "15",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-392",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-07-31T07:45:00+05:00",
                    end: "2025-07-31T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "15",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-393",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "5010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-07-31T08:45:00+05:00",
                    end: "2025-07-31T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "15",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-394",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "533 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-07-31T09:15:00+05:00",
                    end: "2025-07-31T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "5",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-395",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "5909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-07-31T10:00:00+05:00",
                    end: "2025-07-31T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "20",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-396",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-07-31T11:03:00+05:00",
                    end: "2025-07-31T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "15",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-397",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-07-31T11:57:00+05:00",
                    end: "2025-07-31T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "20",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-398",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-07-31T12:42:00+05:00",
                    end: "2025-07-31T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "20",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-399",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-07-31T13:23:00+05:00",
                    end: "2025-07-31T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "5",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-400",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:03 PM",
                    endTime: "3:45 PM",
                    address: "15701 Royal Birkdale Dr, Dallas, TX",
                    contract: "Irrigation Service 9893",
                    start: "2025-07-31T14:03:00+05:00",
                    end: "2025-07-31T15:45:00+05:00",
                    origin: {
                      lat: 32.9735088764031,
                      lng: -96.63629889037135,
                    },
                    drive_time: "102",
                    durationMinutes: 102,
                  },
                  {
                    id: "landscape_maintenance-visit-401",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T15:45:00+05:00",
                    end: "2025-07-31T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-498",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "108636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "7",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-499",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-07-31T07:37:00+05:00",
                    end: "2025-07-31T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-500",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-07-31T08:40:00+05:00",
                    end: "2025-07-31T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-501",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-07-31T09:17:00+05:00",
                    end: "2025-07-31T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-502",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-07-31T09:54:00+05:00",
                    end: "2025-07-31T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-503",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-07-31T11:02:00+05:00",
                    end: "2025-07-31T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "49",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-504",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-07-31T11:56:00+05:00",
                    end: "2025-07-31T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-505",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-07-31T13:40:00+05:00",
                    end: "2025-07-31T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-506",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-07-31T14:23:00+05:00",
                    end: "2025-07-31T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-507",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-07-31T14:55:00+05:00",
                    end: "2025-07-31T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-508",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:20:00+05:00",
                    end: "2025-07-31T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-600",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "158636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-601",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "7:45 AM",
                    endTime: "8:30 AM",
                    address: "15771 E Muirfield Rd, Garland, TX",
                    contract: "Irrigation Service 1485",
                    start: "2025-07-31T07:45:00+05:00",
                    end: "2025-07-31T08:30:00+05:00",
                    origin: {
                      lat: 32.96412945498084,
                      lng: -96.62252673311261,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                  },
                  {
                    id: "landscape_maintenance-visit-602",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "8:45 AM",
                    endTime: "9:10 AM",
                    address: "155010 Sandestin Ct, Garland, TX",
                    contract: "Irrigation Service 3840",
                    start: "2025-07-31T08:45:00+05:00",
                    end: "2025-07-31T09:10:00+05:00",
                    origin: {
                      lat: 32.9657097828662,
                      lng: -96.62958819500513,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-603",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "9:15 AM",
                    endTime: "9:40 AM",
                    address: "553 Rivercove Dr, Garland, TX",
                    contract: "Irrigation Service 4895",
                    start: "2025-07-31T09:15:00+05:00",
                    end: "2025-07-31T09:40:00+05:00",
                    origin: {
                      lat: 32.96508660573363,
                      lng: -96.63301201299527,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-604",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "10:00 AM",
                    endTime: "10:48 AM",
                    address: "205909 Hilton Head Dr, Sachse, TX",
                    contract: "Irrigation Service 3915",
                    start: "2025-07-31T10:00:00+05:00",
                    end: "2025-07-31T10:48:00+05:00",
                    origin: {
                      lat: 32.9676465304545,
                      lng: -96.63428771706168,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-605",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "11:03 AM",
                    endTime: "11:37 AM",
                    address: "15 Turtle Cove Rd, Sachse, TX",
                    contract: "Irrigation Service 5737",
                    start: "2025-07-31T11:03:00+05:00",
                    end: "2025-07-31T11:37:00+05:00",
                    origin: {
                      lat: 32.96581820970136,
                      lng: -96.63760545430519,
                    },
                    drive_time: "34",
                    durationMinutes: 34,
                  },
                  {
                    id: "landscape_maintenance-visit-606",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "11:57 AM",
                    endTime: "12:22 PM",
                    address:
                      "20 Firewheel Town Village, 5151 N President George Bush Hwy, Richardson, TX",
                    contract: "Irrigation Service 7051",
                    start: "2025-07-31T11:57:00+05:00",
                    end: "2025-07-31T12:22:00+05:00",
                    origin: {
                      lat: 32.96239223616148,
                      lng: -96.64071988844,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-607",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "12:42 PM",
                    endTime: "1:18 PM",
                    address: "20518 Palm Desert Dr, Richardson, TX",
                    contract: "Irrigation Service 9661",
                    start: "2025-07-31T12:42:00+05:00",
                    end: "2025-07-31T13:18:00+05:00",
                    origin: {
                      lat: 32.96018961921745,
                      lng: -96.6297992560787,
                    },
                    drive_time: "36",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-608",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "5105 La Costa Ct, Murphy, TX",
                    contract: "Irrigation Service 1261",
                    start: "2025-07-31T13:23:00+05:00",
                    end: "2025-07-31T13:48:00+05:00",
                    origin: {
                      lat: 32.9693455855513,
                      lng: -96.62995901394756,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-609",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:45 PM",
                    endTime: "4:15 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:45:00+05:00",
                    end: "2025-07-31T16:15:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-660",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "188636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-661",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:48 AM",
                    endTime: "3:28 PM",
                    address: "460121500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 4456",
                    start: "2025-07-31T07:48:00+05:00",
                    end: "2025-07-31T15:28:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "460",
                    durationMinutes: 460,
                  },
                  {
                    id: "landscape_maintenance-visit-662",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-07-31T15:40:00+05:00",
                    end: "2025-07-31T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    date: "2026-05-29",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-402",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "7",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-403",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-08-01T07:37:00+05:00",
                    end: "2025-08-01T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "7",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-404",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-08-01T08:40:00+05:00",
                    end: "2025-08-01T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-405",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-08-01T09:17:00+05:00",
                    end: "2025-08-01T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-406",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-08-01T09:54:00+05:00",
                    end: "2025-08-01T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "12",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-407",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-08-01T11:02:00+05:00",
                    end: "2025-08-01T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "20",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-408",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-08-01T11:56:00+05:00",
                    end: "2025-08-01T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-409",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-08-01T13:40:00+05:00",
                    end: "2025-08-01T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-410",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-08-01T14:23:00+05:00",
                    end: "2025-08-01T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "18",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-411",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-08-01T14:55:00+05:00",
                    end: "2025-08-01T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-412",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T15:20:00+05:00",
                    end: "2025-08-01T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "irrigation",
        name: "Irrigation",
        managers: [
          {
            id: "irrigation-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "IR 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-509",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "7",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-510",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-08-01T07:37:00+05:00",
                    end: "2025-08-01T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-511",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-08-01T08:40:00+05:00",
                    end: "2025-08-01T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-512",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-08-01T09:17:00+05:00",
                    end: "2025-08-01T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-513",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-08-01T09:54:00+05:00",
                    end: "2025-08-01T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-514",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-08-01T11:02:00+05:00",
                    end: "2025-08-01T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "49",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-515",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-08-01T11:56:00+05:00",
                    end: "2025-08-01T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-516",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-08-01T13:40:00+05:00",
                    end: "2025-08-01T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-517",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-08-01T14:23:00+05:00",
                    end: "2025-08-01T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-518",
                    title: "Mockingbird Medical Plaza",
                    status: "scheduled",
                    startTime: "2:55 PM",
                    endTime: "3:20 PM",
                    address: "Midway Manor Park, Adrian Dr, Dallas, TX",
                    contract: "Irrigation Service 1576",
                    start: "2025-08-01T14:55:00+05:00",
                    end: "2025-08-01T15:20:00+05:00",
                    origin: {
                      lat: 32.85250133057595,
                      lng: -96.84200308204638,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-519",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T15:20:00+05:00",
                    end: "2025-08-01T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "enhancements",
        name: "Enhancements",
        managers: [
          {
            id: "enhancements-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "EN 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-610",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "78636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-611",
                    title: "Eastwood HOA",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:29 AM",
                    address: "76900 Aubrey Ave, Dallas, TX",
                    contract: "Irrigation Service 1792",
                    start: "2025-08-01T07:37:00+05:00",
                    end: "2025-08-01T08:29:00+05:00",
                    origin: {
                      lat: 32.83700833534181,
                      lng: -96.84013323531072,
                    },
                    drive_time: "52",
                    durationMinutes: 52,
                    workOrders: ["Weekly service", "Pruning"],
                  },
                  {
                    id: "landscape_maintenance-visit-612",
                    title: "Bishop Arts Retail",
                    status: "scheduled",
                    startTime: "8:40 AM",
                    endTime: "9:05 AM",
                    address: "113333 Manor Way, Dallas, TX",
                    contract: "Irrigation Service 4270",
                    start: "2025-08-01T08:40:00+05:00",
                    end: "2025-08-01T09:05:00+05:00",
                    origin: {
                      lat: 32.83392392795613,
                      lng: -96.8346635389103,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-613",
                    title: "Elmwood Bungalows",
                    status: "scheduled",
                    startTime: "9:17 AM",
                    endTime: "9:42 AM",
                    address: "126550 Lemmon Ave, Dallas, TX",
                    contract: "Irrigation Service 8441",
                    start: "2025-08-01T09:17:00+05:00",
                    end: "2025-08-01T09:42:00+05:00",
                    origin: {
                      lat: 32.83807155912403,
                      lng: -96.83268367604714,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-614",
                    title: "Kessler Plaza",
                    status: "scheduled",
                    startTime: "9:54 AM",
                    endTime: "10:42 AM",
                    address: "126706 Mabel Ave, Dallas, TX",
                    contract: "Irrigation Service 1653",
                    start: "2025-08-01T09:54:00+05:00",
                    end: "2025-08-01T10:42:00+05:00",
                    origin: {
                      lat: 32.83967116410867,
                      lng: -96.83405180973058,
                    },
                    drive_time: "48",
                    durationMinutes: 48,
                  },
                  {
                    id: "landscape_maintenance-visit-615",
                    title: "Lakeside Apartments",
                    status: "scheduled",
                    startTime: "11:02 AM",
                    endTime: "11:51 AM",
                    address: "206723 Webster St, Dallas, TX",
                    contract: "Irrigation Service 9136",
                    start: "2025-08-01T11:02:00+05:00",
                    end: "2025-08-01T11:51:00+05:00",
                    origin: {
                      lat: 32.84036633885155,
                      lng: -96.83346094910097,
                    },
                    drive_time: "49",
                    durationMinutes: 49,
                  },
                  {
                    id: "landscape_maintenance-visit-616",
                    title: "Dallas Garden Center",
                    status: "scheduled",
                    startTime: "11:56 AM",
                    endTime: "1:33 PM",
                    address: "56724 Tyree St, Dallas, TX",
                    contract: "Irrigation Service 6557",
                    start: "2025-08-01T11:56:00+05:00",
                    end: "2025-08-01T13:33:00+05:00",
                    origin: {
                      lat: 32.840401086974026,
                      lng: -96.83200598585526,
                    },
                    drive_time: "97",
                    durationMinutes: 97,
                    workOrders: [
                      "Weekly service",
                      "Pruning",
                      "Spring cleanup",
                      "Fall cleanup",
                    ],
                  },
                  {
                    id: "landscape_maintenance-visit-617",
                    title: "Rosemont HOA",
                    status: "scheduled",
                    startTime: "1:40 PM",
                    endTime: "2:05 PM",
                    address: "77015 Kenwell St, Dallas, TX",
                    contract: "Irrigation Service 4700",
                    start: "2025-08-01T13:40:00+05:00",
                    end: "2025-08-01T14:05:00+05:00",
                    origin: {
                      lat: 32.84296759045802,
                      lng: -96.82767335878253,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-618",
                    title: "Casa View Plaza",
                    status: "scheduled",
                    startTime: "2:23 PM",
                    endTime: "2:48 PM",
                    address: "185530 Wenonah Dr, Dallas, TX",
                    contract: "Irrigation Service 7150",
                    start: "2025-08-01T14:23:00+05:00",
                    end: "2025-08-01T14:48:00+05:00",
                    origin: {
                      lat: 32.841245057214906,
                      lng: -96.81630386115987,
                    },
                    drive_time: "25",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-619",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:20 PM",
                    endTime: "3:50 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T15:20:00+05:00",
                    end: "2025-08-01T15:50:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "construction",
        name: "Construction",
        managers: [
          {
            id: "construction-mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-d-003",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-c-002",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-d1-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-663",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "188636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-664",
                    title: "Hollow Creek Townhomes",
                    status: "scheduled",
                    startTime: "7:48 AM",
                    endTime: "3:28 PM",
                    address: "460121500 Rusdell Dr, Dallas, TX",
                    contract: "Construction Project 4456",
                    start: "2025-08-01T07:48:00+05:00",
                    end: "2025-08-01T15:28:00+05:00",
                    origin: {
                      lat: 32.79676800130117,
                      lng: -96.96317277408379,
                    },
                    drive_time: "460",
                    durationMinutes: 460,
                  },
                  {
                    id: "landscape_maintenance-visit-665",
                    title: "Evergreen’s Yard",
                    status: "scheduled",
                    startTime: "3:40 PM",
                    endTime: "4:10 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "-",
                    start: "2025-08-01T15:40:00+05:00",
                    end: "2025-08-01T16:10:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "30",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
